"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2719],{

/***/ 22695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ actions_GroupRequestAction; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/AcceptGroupRequest.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AcceptGroupRequest($requestId: ObjectId!) {\n    acceptGroupRequest(requestId: $requestId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var AcceptGroupRequest = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/DeclineGroupRequest.ts

function DeclineGroupRequest_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclineGroupRequest($requestId: ObjectId!) {\n    declineGroupRequest(requestId: $requestId)\n  }\n"
    ]);
    DeclineGroupRequest_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DeclineGroupRequest = ((0,lib/* gql */.Ps)(DeclineGroupRequest_templateObject()));

// EXTERNAL MODULE: ./lib/mutations/DismissActionCenter.ts
var DismissActionCenter = __webpack_require__(32785);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
// EXTERNAL MODULE: ./components/icons/CheckIcon.tsx
var CheckIcon = __webpack_require__(77820);
// EXTERNAL MODULE: ./components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(80937);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
;// CONCATENATED MODULE: ./components/actions/GroupRequestAction.tsx




















function GroupRequestAction(param) {
    var action = param.action, entityType = param.entityType;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), joinedGroup = ref[0], setJoinedGroup = ref[1];
    var ref1 = (0,react.useState)(false), declinedGroup = ref1[0], setDeclinedGroup = ref1[1];
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissActionCenter/* default */.Z,
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    padding: 12,
                    backgroundColor: palette/* white */.ix,
                    ":hover": {
                        backgroundColor: palette/* washGray */.aF
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                        size: 46,
                        image: action.group.logo,
                        name: action.group.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        ml: 12,
                        mr: "auto",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                fontSize: 14,
                                color: palette/* mediumGray */.rF,
                                margin: 0,
                                lineHeight: "18px"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(action.inviter.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            color: palette/* primary */.T$,
                                            fontWeight: 600,
                                            ":hover": {
                                                textDecoration: "underline !important"
                                            }
                                        },
                                        children: action.inviter.fullName
                                    })
                                }),
                                " ",
                                entityType === "vendor" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "invited your vendor to join the group {groupName}",
                                    id: "lGjb4l",
                                    values: {
                                        groupName: action.group.name
                                    }
                                }),
                                entityType === "government" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "invited your government to join the group {groupName}",
                                    id: "1AZSUN",
                                    values: {
                                        groupName: action.group.name
                                    }
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        color: palette/* sealBlue */.N9,
                                        fontSize: 12,
                                        whiteSpace: "nowrap"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                        value: action.createdAt
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            width: 170,
                            minWidth: 170,
                            justifyContent: "flex-end"
                        },
                        children: [
                            joinedGroup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* greenBlue */.TG
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 6,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Joined",
                                                    id: "l8wanU"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            declinedGroup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                ml: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* red */.Q6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon/* default */.Z, {
                                            fill: palette/* red */.Q6,
                                            variation: "thick",
                                            width: 15,
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            ml: 8,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Declined",
                                                    id: "uRYIb9"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            !joinedGroup && !declinedGroup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridAutoFlow: "column",
                                    alignItems: "center",
                                    gridColumnGap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: AcceptGroupRequest,
                                        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                            "Selfie",
                                            "Government",
                                            "Group"
                                        ]),
                                        onCompleted: function() {
                                            router.push("/groups/[groupSlug]", "/groups/".concat(action.group.slug));
                                        },
                                        children: function(acceptGroupRequest) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                                                children: function(param) {
                                                    var bind = param.bind, hovered = param.hovered;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        theme: hovered ? "primary" : "secondary",
                                                        size: "xsmall",
                                                        color: palette/* innovatorBlue */.LD,
                                                        style: {
                                                            opacity: 1,
                                                            backgroundColor: hovered ? palette/* innovatorBlue */.LD : palette/* white */.ix,
                                                            width: 100
                                                        }
                                                    }, bind), {
                                                        onClick: function() {
                                                            acceptGroupRequest({
                                                                variables: {
                                                                    requestId: action._id
                                                                }
                                                            });
                                                            dismissActionCenter();
                                                            setJoinedGroup(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Join Group",
                                                                id: "8hYalv"
                                                            })
                                                        })
                                                    }));
                                                }
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                        mutation: DeclineGroupRequest,
                                        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                            "Group"
                                        ]),
                                        children: function(declineGroupRequest) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    cursor: "pointer",
                                                    fontSize: 12,
                                                    color: palette/* red */.Q6,
                                                    ":hover": {
                                                        textDecoration: "underline"
                                                    }
                                                },
                                                onClick: function() {
                                                    var message = intl.formatMessage({
                                                        defaultMessage: "Are you sure you want to decline the invite to {groupName}?",
                                                        id: "V4iue9"
                                                    }, {
                                                        groupName: action.group.name
                                                    });
                                                    if (window.confirm(message)) {
                                                        declineGroupRequest({
                                                            variables: {
                                                                requestId: action._id
                                                            }
                                                        });
                                                        dismissActionCenter();
                                                        setDeclinedGroup(true);
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Decline",
                                                    id: "pvtgR2"
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var actions_GroupRequestAction = (GroupRequestAction);


/***/ }),

/***/ 45896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49980);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82789);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38085);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95576);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48182);
/* harmony import */ var lodash_fp_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90489);
/* harmony import */ var _lib_queries_ConnectQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76896);
/* harmony import */ var _types_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43845);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27068);
/* harmony import */ var _components_profile_EmptyBlocks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32796);
/* harmony import */ var _components_feed_card_LoadingFeedCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25936);
/* harmony import */ var _components_feed_FeedItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93742);

















function Feed(param) {
    var targetId = param.targetId, targetType = param.targetType, router = param.router, context = param.context, _showNoPosts = param.showNoPosts, showNoPosts = _showNoPosts === void 0 ? true : _showNoPosts, feedLimit = param.feedLimit;
    var user = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_6__/* .useSelfie */ .yD)();
    var groupSlug = lodash_fp_get__WEBPACK_IMPORTED_MODULE_0___default()("query.groupSlug", router);
    var isContentTab = lodash_fp_get__WEBPACK_IMPORTED_MODULE_0___default()("query.content", router) === "connect";
    var limit = feedLimit || 15;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_11__/* .Query */ .A, {
        query: _lib_queries_ConnectQuery__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        notifyOnNetworkStatusChange: true,
        variables: {
            targetId: targetId || null,
            targetType: targetType || null,
            limit: limit,
            beforeThisId: null,
            excludeUser: null
        },
        children: function(param) {
            var data = param.data, fetchMore = param.fetchMore, loading = param.loading;
            if (!loading && data && showNoPosts && data.connect && data.connect.items.length === 0 && (targetType === _types_types__WEBPACK_IMPORTED_MODULE_5__/* .IConnectTargetType.Group */ .QY.Group || targetType === _types_types__WEBPACK_IMPORTED_MODULE_5__/* .IConnectTargetType.Government */ .QY.Government && user && user.__typename === "GovernmentUser" && user.government && user.government._id === targetId || targetType === _types_types__WEBPACK_IMPORTED_MODULE_5__/* .IConnectTargetType.Vendor */ .QY.Vendor && user && user.__typename === "VendorUser" && user.company && user.company._id === targetId)) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_profile_EmptyBlocks__WEBPACK_IMPORTED_MODULE_7__/* .NoPosts */ .o0, {});
            }
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 16
                },
                children: [
                    data && data.connect && data.connect.items.map(function(feedItem) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_feed_FeedItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            feedItem: feedItem,
                            context: context
                        }, feedItem._id);
                    }),
                    loading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_feed_card_LoadingFeedCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    groupSlug && !isContentTab && !loading && data && data.connect.items.length > 0 && data.connect.items.length < data.connect.totalCount && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        passHref: true,
                        href: "/groups/[groupSlug]",
                        as: "/groups/".concat(groupSlug, "?content=connect&feedLimit=15"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("a", {
                            css: {
                                textTransform: "uppercase",
                                justifySelf: "center",
                                background: "none",
                                outline: "none",
                                border: "none",
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_12__/* .primary */ .T$,
                                letterSpacing: 1,
                                fontSize: 13,
                                fontWeight: 600,
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                defaultMessage: "View More",
                                id: "QQSdHP"
                            })
                        })
                    }),
                    (!groupSlug || groupSlug && isContentTab) && !loading && data && data.connect.items.length > 0 && data.connect.items.length < data.connect.totalCount && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("button", {
                        type: "button",
                        css: {
                            textTransform: "uppercase",
                            justifySelf: "center",
                            background: "none",
                            outline: "none",
                            border: "none",
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_12__/* .primary */ .T$,
                            letterSpacing: 1,
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: "pointer"
                        },
                        onClick: function() {
                            if (!data) {
                                return null;
                            }
                            fetchMore({
                                query: _lib_queries_ConnectQuery__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                variables: {
                                    targetId: targetId,
                                    targetType: targetType,
                                    beforeThisId: data.connect.items[data.connect.items.length - 1]._id,
                                    limit: limit
                                },
                                updateQuery: function(previousQueryResult, param) {
                                    var fetchMoreResult = param.fetchMoreResult;
                                    if (fetchMoreResult) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, previousQueryResult), {
                                            connect: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, fetchMoreResult.connect), {
                                                items: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(previousQueryResult.connect.items).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(fetchMoreResult.connect.items))
                                            })
                                        });
                                    }
                                    return previousQueryResult;
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            defaultMessage: "View More",
                            id: "QQSdHP"
                        })
                    })
                ]
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(Feed));


/***/ }),

/***/ 47128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getFormattedBudget; },
/* harmony export */   "Z": function() { return /* binding */ GovernmentBudget; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4587);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);



function GovernmentBudget(param) {
    var budget = param.budget, currency = param.currency;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        children: getFormattedBudget(budget, currency)
    });
};
function getFormattedBudget(budget, currency) {
    var formatted = budget > 1000 ? numeral__WEBPACK_IMPORTED_MODULE_1___default()(budget).format("0.0a") : budget;
    if (currency === "USD") {
        return "$".concat(formatted);
    }
    if (currency === "GBP") {
        return "\xa3".concat(formatted);
    }
    if (currency === "EUR") {
        return "€".concat(formatted);
    }
    if (currency === "CAD") {
        return "CA$".concat(formatted);
    }
    if (currency === "AUD") {
        return "AU$".concat(formatted);
    }
    if (currency === "NZD") {
        return "NZ$".concat(formatted);
    }
    if (currency === "ZAR") {
        return "R".concat(formatted);
    }
    if (currency === "BRL") {
        return "R$".concat(formatted);
    }
    if (currency === "SEK") {
        return "SEK".concat(formatted);
    }
    if (currency === "DKK") {
        return "DKK".concat(formatted);
    }
    if (currency === "MXN") {
        return "MX$".concat(formatted);
    }
    if (currency === "ARS") {
        return "ARS".concat(formatted);
    }
    return "".concat(formatted);
}


/***/ }),

/***/ 20838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GovernmentPopulation; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4587);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);



function GovernmentPopulation(param) {
    var population = param.population;
    if (population < 1000) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
            children: population
        });
    }
    if (population >= 1000 && population < 1000000) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
            children: numeral__WEBPACK_IMPORTED_MODULE_1___default()(population).format("0.0a")
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        children: numeral__WEBPACK_IMPORTED_MODULE_1___default()(population).format("0.00a")
    });
};


/***/ }),

/***/ 23742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var BadgeCheckIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "aria-hidden": "true",
        "data-prefix": "fal",
        "data-icon": "badge-check",
        className: "prefix__svg-inline--fa prefix__fa-badge-check prefix__fa-w-16",
        height: 33,
        width: 33,
        viewBox: "0 0 512 512"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            fill: "currentColor",
            d: "M345.34 182.46a7.98 7.98 0 00-5.66-2.34c-2.05 0-4.1.78-5.66 2.34L226.54 289.94l-48.57-48.57a7.98 7.98 0 00-5.66-2.34c-2.05 0-4.1.78-5.66 2.34l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l65.54 65.54c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.65-2.34l124.45-124.45c3.12-3.12 3.12-8.19 0-11.31l-11.3-11.31zM512 256c0-35.5-19.4-68.2-49.6-85.5 9.1-33.6-.3-70.4-25.4-95.5s-61.9-34.5-95.5-25.4C324.2 19.4 291.5 0 256 0s-68.2 19.4-85.5 49.6c-33.6-9.1-70.4.3-95.5 25.4s-34.5 61.9-25.4 95.5C19.4 187.8 0 220.5 0 256s19.4 68.2 49.6 85.5c-9.1 33.6.3 70.4 25.4 95.5 26.5 26.5 63.4 34.1 95.5 25.4 17.4 30.2 50 49.6 85.5 49.6s68.1-19.4 85.5-49.6c32.7 8.9 69.4.7 95.5-25.4 25.1-25.1 34.5-61.9 25.4-95.5 30.2-17.3 49.6-50 49.6-85.5zm-91.1 68.3c5.3 11.8 29.5 54.1-6.5 90.1-28.9 28.9-57.5 21.3-90.1 6.5C319.7 433 307 480 256 480c-52.1 0-64.7-49.5-68.3-59.1-32.6 14.8-61.3 22.2-90.1-6.5-36.8-36.7-10.9-80.5-6.5-90.1C79 319.7 32 307 32 256c0-52.1 49.5-64.7 59.1-68.3-5.3-11.8-29.5-54.1 6.5-90.1 36.8-36.9 80.8-10.7 90.1-6.5C192.3 79 205 32 256 32c52.1 0 64.7 49.5 68.3 59.1 11.8-5.3 54.1-29.5 90.1 6.5 36.8 36.7 10.9 80.5 6.5 90.1C433 192.3 480 205 480 256c0 52.1-49.5 64.7-59.1 68.3z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BadgeCheckIcon);


/***/ }),

/***/ 77820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var CheckIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        "aria-hidden": "true",
        "data-prefix": "far",
        "data-icon": "check",
        className: "prefix__svg-inline--fa prefix__fa-check prefix__fa-w-16",
        width: 20,
        height: 20,
        viewBox: "0 0 512 512"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            fill: "currentColor",
            d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckIcon);


/***/ }),

/***/ 80937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





var CloseIcon = function(_param) {
    var _fill = _param.fill, fill = _fill === void 0 ? "#666" : _fill, _variation = _param.variation, variation = _variation === void 0 ? "normal" : _variation, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "fill",
        "variation"
    ]);
    if (variation === "thick") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: 12,
            height: 12,
            viewBox: "0 0 47.971 47.971"
        }, props), {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                fill: fill,
                d: "M28.228 23.986L47.092 5.122a2.998 2.998 0 000-4.242 2.998 2.998 0 00-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 00-4.242 0 2.998 2.998 0 000 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 104.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 000-4.242L28.228 23.986z"
            })
        }));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: 12,
        height: 12,
        viewBox: "0 0 64 64"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            fill: fill,
            d: "M28.941 31.786L.613 60.114a2.014 2.014 0 102.848 2.849l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59a2.014 2.014 0 001.424-3.439L35.064 31.786 63.41 3.438A2.014 2.014 0 1060.562.589L32.003 29.15 3.441.59A2.015 2.015 0 00.593 3.439l28.348 28.347z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIcon);


/***/ }),

/***/ 76745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Compass; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function Compass(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 510 510"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M255 226.95c-15.3 0-28.05 12.75-28.05 28.05s12.75 28.05 28.05 28.05 28.05-12.75 28.05-28.05-12.75-28.05-28.05-28.05zM255 0C114.75 0 0 114.75 0 255s114.75 255 255 255 255-114.75 255-255S395.25 0 255 0zm56.1 311.1L102 408l96.9-209.1L408 102l-96.9 209.1z",
            fill: "#999",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 53849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ShowMore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95576);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90489);






var ShowMore = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .sealBlue */ .N9,
            fontSize: 12,
            textAlign: "center",
            cursor: "pointer",
            borderTop: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .lightestGray */ .v2),
            "&:hover": {
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_4__/* .darkGray */ .O5
            }
        },
        role: "button",
        "aria-label": "Show more"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};


/***/ }),

/***/ 13005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98973);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95576);
/* harmony import */ var _govlaunch_popover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70271);
/* harmony import */ var _govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77876);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56365);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69057);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90489);
/* harmony import */ var react_powerplug__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41491);
/* harmony import */ var _components_DelayedHover__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94662);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67459);
/* harmony import */ var _lib_hooks_useIsTablet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2518);
/* harmony import */ var _lib_hooks_useShowMoreCounter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87386);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27068);
/* harmony import */ var _components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71985);
/* harmony import */ var _components_invite_Collaborator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84743);
/* harmony import */ var _components_invite_InviteModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96805);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52126);
/* harmony import */ var _components_profile_ShowMore__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(53849);























var Team = function(param) {
    var members = param.members, viewerIsMember = param.viewerIsMember, viewerCanInviteMembers = param.viewerCanInviteMembers, viewerCanRemoveMembers = param.viewerCanRemoveMembers, _viewerCanSeeTeam = param.viewerCanSeeTeam, viewerCanSeeTeam = _viewerCanSeeTeam === void 0 ? true : _viewerCanSeeTeam, targetType = param.targetType, targetId = param.targetId;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    var isTablet = (0,_lib_hooks_useIsTablet__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var ref = (0,_lib_hooks_useShowMoreCounter__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((members || []).length, isTablet ? 3 : 8), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    if (!viewerCanSeeTeam || (members === null || members === void 0 ? void 0 : members.length) === 0 && !viewerCanInviteMembers) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
            css: {
                backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .white */ .ix,
                borderRadius: 5,
                border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2),
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
                    css: {
                        padding: 16,
                        borderBottom: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                        css: {
                            textTransform: "uppercase",
                            fontSize: 12,
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .sealBlue */ .N9,
                            letterSpacing: 0.5,
                            fontWeight: 500
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            defaultMessage: "Team",
                            id: "wsUmh9"
                        })
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                    css: {
                        padding: 16,
                        fontSize: 15,
                        textAlign: "center",
                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .darkGray */ .O5
                    },
                    children: [
                        "\uD83D\uDEAB ",
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            defaultMessage: "You do not have access to view this content",
                            id: "x2z+82"
                        })
                    ]
                })
            ]
        });
    }
    if (members.length === 1) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(SingleTeamMember, {
            member: members[0],
            targetType: targetType,
            targetId: targetId,
            viewerIsMember: viewerIsMember
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
        "data-intercom-target": viewerIsMember ? "".concat(targetType === "GOVERNMENT" ? "Government" : "Vendor", " Team") : null,
        css: {
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .white */ .ix,
            borderRadius: 5,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2),
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                css: {
                    padding: 15,
                    borderBottom: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                        css: {
                            textTransform: "uppercase",
                            fontSize: 12,
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .sealBlue */ .N9,
                            letterSpacing: 0.5,
                            fontWeight: 500
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            defaultMessage: "Team ({membersCount})",
                            id: "9HIlM0",
                            values: {
                                membersCount: members.length
                            }
                        })
                    }),
                    targetType === "GOVERNMENT" && viewerCanInviteMembers && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_6__/* .Toggle */ .ZD, {
                        children: function(param) {
                            var isOpen = param.on, toggle = param.toggle;
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                        role: "button",
                                        "aria-label": "Invite your team",
                                        className: "invite-government-team",
                                        onClick: toggle,
                                        css: {
                                            fontWeight: 600,
                                            fontSize: 12,
                                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .primary */ .T$,
                                            cursor: "pointer",
                                            textTransform: "uppercase"
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            defaultMessage: "Invite others",
                                            id: "+s1O1O"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_invite_InviteModal__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: intl.formatMessage({
                                            defaultMessage: "Invite Team Members",
                                            id: "LeF5J5"
                                        }),
                                        subtitle: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                defaultMessage: "They’ll be granted access to your <strong>Government</strong>",
                                                id: "HH5Cyh",
                                                values: {
                                                    // eslint-disable-next-line react/display-name
                                                    strong: function(text) {
                                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("strong", {
                                                            children: text
                                                        });
                                                    }
                                                }
                                            })
                                        }),
                                        targetType: targetType,
                                        targetId: targetId,
                                        isOpen: isOpen,
                                        onRequestClose: toggle
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            isMobile ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
                css: {
                    padding: 10
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Grid */ .rj, {
                    gutter: 15,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .RowWrap */ .xv, {
                        children: members.slice(0, offset).map(function(member) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Col */ .JX, {
                                mt: 10,
                                mb: 10,
                                width: 1,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            size: 48,
                                            image: member.avatar,
                                            name: member.fullName,
                                            innovator: member.__typename === "GovernmentUser" ? member.isInnovator : false
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                                            css: {
                                                marginLeft: 15,
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                                    css: {
                                                        fontSize: 16,
                                                        fontWeight: 600
                                                    },
                                                    children: member.fullName
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                                    css: {
                                                        fontSize: 14,
                                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .mediumGray */ .rF
                                                    },
                                                    children: member.jobTitle
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, member._id);
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Grid */ .rj, {
                gutter: 15,
                children: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_3__.chunk)(4, members.slice(0, offset)).map(function(row, index) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .RowWrap */ .xv, {
                        mt: 15,
                        mb: 15,
                        justifyContent: "flex-start",
                        children: row.map(function(member) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Col */ .JX, {
                                width: 3 / 12,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: member.fullName ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_invite_Collaborator__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    targetType: targetType,
                                    targetId: targetId,
                                    viewerCanRemove: viewerCanRemoveMembers || false,
                                    user: member,
                                    removeText: "Remove from Team",
                                    size: 60
                                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_DelayedHover__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    ms: 300,
                                    children: function(_param) /*#__PURE__*/ {
                                        var hover = _param.hover, bind = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_param, [
                                            "hover"
                                        ]);
                                        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_popover__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            placement: "top",
                                            isOpen: hover,
                                            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .innovatorBlue */ .LD,
                                            borderColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .innovatorBlue */ .LD,
                                            style: {
                                                boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
                                            },
                                            render: function() {
                                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                                                    css: {
                                                        padding: 10,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .white */ .ix
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                                            css: {
                                                                fontSize: 14,
                                                                fontWeight: 600
                                                            },
                                                            children: member.fullName
                                                        }),
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                                            css: {
                                                                fontSize: 12,
                                                                fontWeight: 400
                                                            },
                                                            children: member.jobTitle
                                                        })
                                                    ]
                                                });
                                            },
                                            children: function(param) {
                                                var innerRef = param.innerRef;
                                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                                    ref: innerRef
                                                }, bind), {
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        width: 60,
                                                        height: 60
                                                    })
                                                }));
                                            }
                                        });
                                    }
                                })
                            }, member._id);
                        })
                    }, index);
                })
            }),
            hasMore && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_profile_ShowMore__WEBPACK_IMPORTED_MODULE_15__/* .ShowMore */ .g, {
                onClick: showMore
            })
        ]
    });
};
var SingleTeamMember = function(param) {
    var member = param.member, viewerIsMember = param.viewerIsMember, targetType = param.targetType, targetId = param.targetId;
    var user = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_10__/* .useSelfie */ .yD)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
        "data-intercom-target": viewerIsMember ? "Government Team" : null,
        css: {
            backgroundColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .white */ .ix,
            borderRadius: 5,
            border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2),
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                css: {
                    padding: 15,
                    textTransform: "uppercase",
                    fontSize: 12,
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .sealBlue */ .N9,
                    display: "flex",
                    alignItems: "center",
                    letterSpacing: 0.5,
                    fontWeight: 500,
                    borderBottom: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .lightestGray */ .v2)
                },
                children: [
                    user && user._id === member._id ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            defaultMessage: "For now it's just you!",
                            id: "lfNa1Y"
                        })
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            defaultMessage: "Team",
                            id: "wsUmh9"
                        })
                    }),
                    targetType === "GOVERNMENT" && viewerIsMember && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_6__/* .Toggle */ .ZD, {
                        children: function(param) {
                            var isOpen = param.on, toggle = param.toggle;
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                        role: "button",
                                        "aria-label": "Invite your team",
                                        css: {
                                            marginLeft: "auto",
                                            fontWeight: 600,
                                            fontSize: 11,
                                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .primary */ .T$,
                                            cursor: "pointer"
                                        },
                                        onClick: toggle,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            defaultMessage: "Invite others",
                                            id: "+s1O1O"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_invite_InviteModal__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: intl.formatMessage({
                                            defaultMessage: "Invite Team Members",
                                            id: "LeF5J5"
                                        }),
                                        subtitle: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                defaultMessage: "They’ll be granted access to your <strong>Government</strong>",
                                                id: "HH5Cyh",
                                                values: {
                                                    // eslint-disable-next-line react/display-name
                                                    strong: function(text) {
                                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("strong", {
                                                            children: text
                                                        });
                                                    }
                                                }
                                            })
                                        }),
                                        targetType: targetType,
                                        targetId: targetId,
                                        isOpen: isOpen,
                                        onRequestClose: toggle
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                css: {
                    padding: 15,
                    display: "flex",
                    justifyContent: "center",
                    alignItem: "center",
                    flexDirection: "column"
                },
                children: [
                    member.slug ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        passHref: true,
                        href: "/[userSlug]/[[...tab]]",
                        as: "/@".concat(member.slug),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("a", {
                            css: {
                                margin: 0,
                                display: "flex",
                                textDecoration: "none",
                                justifyContent: "center"
                            },
                            children: member.fullName ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                size: 80,
                                name: member.fullName,
                                image: member.avatar,
                                innovator: member.__typename === "GovernmentUser" ? member.isInnovator : false
                            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
                                css: {
                                    width: 80,
                                    height: 80
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    width: 80,
                                    height: 80
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("div", {
                        css: {
                            width: 80,
                            height: 80,
                            margin: "0 auto"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_icons_AnonymousUser__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            width: 80,
                            height: 80
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_14__/* .Margin */ .Zt, {
                        mt: 10,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
                            css: {
                                textAlign: "center"
                            },
                            children: [
                                member.fullName && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(member.slug),
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("a", {
                                        css: {
                                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .text */ .fL,
                                            textDecoration: "none"
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("h4", {
                                            css: {
                                                margin: 0
                                            },
                                            children: member.fullName || member.firstName
                                        })
                                    })
                                }),
                                !member.fullName && member.firstName && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("h4", {
                                    css: {
                                        margin: 0
                                    },
                                    children: member.firstName
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                                    css: {
                                        fontSize: 12,
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .sealBlue */ .N9
                                    },
                                    children: member.jobTitle
                                })
                            ]
                        })
                    }),
                    member.__typename === "GovernmentUser" && member.isInnovator && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_14__/* .Margin */ .Zt, {
                        mt: 10,
                        mb: 10,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)("span", {
                            css: {
                                padding: 5,
                                paddingLeft: 10,
                                paddingRight: 10,
                                border: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .innovatorBlue */ .LD),
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_19__/* .innovatorBlue */ .LD,
                                fontSize: 12,
                                borderRadius: 20,
                                fontWeight: "bold",
                                cursor: "default",
                                userSelect: "none"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                defaultMessage: "Innovator",
                                id: "0RwIiV"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Team);


/***/ }),

/***/ 4758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpgradeAccountBanner; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/icons/MakersIcon.tsx
var MakersIcon = __webpack_require__(52105);
;// CONCATENATED MODULE: ./components/icons/UpgradeDrawIcon.tsx




function UpgradeDrawIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 350,
        height: 231,
        viewBox: "0 0 704 466"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: "0%",
                        y1: "49.777%",
                        x2: "102%",
                        y2: "50.227%",
                        id: "prefix__g",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#3023AE",
                                stopOpacity: 0.924,
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#C86DD7",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: "0%",
                        y1: "48.21%",
                        x2: "102%",
                        y2: "51.825%",
                        id: "prefix__h",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#3023AE",
                                stopOpacity: 0.924,
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#C86DD7",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: "0%",
                        y1: "47.227%",
                        x2: "102%",
                        y2: "52.828%",
                        id: "prefix__i",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#3023AE",
                                stopOpacity: 0.924,
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#C86DD7",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: "0%",
                        y1: ".619%",
                        x2: "102%",
                        y2: "100.368%",
                        id: "prefix__j",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#3023AE",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#C86DD7",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        x: "-2.9%",
                        y: "-4.5%",
                        width: "105.8%",
                        height: "108.9%",
                        filterUnits: "objectBoundingBox",
                        id: "prefix__a",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feOffset", {
                                dy: 2,
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: 2,
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("feMerge", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feMergeNode", {
                                        in: "SourceGraphic"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        x: "-1.7%",
                        y: "-2.7%",
                        width: "103.5%",
                        height: "105.4%",
                        filterUnits: "objectBoundingBox",
                        id: "prefix__c",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feOffset", {
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: 4,
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        x: "-.9%",
                        y: "-14.9%",
                        width: "101.7%",
                        height: "129.7%",
                        filterUnits: "objectBoundingBox",
                        id: "prefix__e",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feOffset", {
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: 2,
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        id: "prefix__b",
                        x: 0,
                        y: 0,
                        width: 686.135,
                        height: 446.472,
                        rx: 5.476
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        id: "prefix__f",
                        d: "M0 0h686.135v40.404H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                filter: "url(#prefix__a)",
                transform: "translate(9 8)",
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        id: "prefix__d",
                        fill: "#fff",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                            xlinkHref: "#prefix__b"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                        fill: "#000",
                        filter: "url(#prefix__c)",
                        xlinkHref: "#prefix__b"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                        fill: "#F9F9F9",
                        xlinkHref: "#prefix__b"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        mask: "url(#prefix__d)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#000",
                                filter: "url(#prefix__e)",
                                xlinkHref: "#prefix__f"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                                fill: "#F5F5F5",
                                xlinkHref: "#prefix__f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        fill: "#34C749",
                        mask: "url(#prefix__d)",
                        cx: 49.901,
                        cy: 20.202,
                        rx: 4.99,
                        ry: 5.387
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        fill: "#FDBC40",
                        mask: "url(#prefix__d)",
                        cx: 33.683,
                        cy: 20.202,
                        rx: 4.99,
                        ry: 5.387
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        fill: "#FC605C",
                        mask: "url(#prefix__d)",
                        cx: 17.465,
                        cy: 20.202,
                        rx: 4.99,
                        ry: 5.387
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: 1.17,
                        y: 1.17,
                        width: 465.192,
                        height: 287.867,
                        rx: 4.633,
                        transform: "translate(14.742 130.572)",
                        fill: "#FFF",
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34,
                        fill: "#FFF",
                        x: 26.442,
                        y: 148.969,
                        width: 215.842,
                        height: 119.387,
                        rx: 4.633
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 35.211,
                        y: 188.083,
                        width: 183.349,
                        height: 4.372,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 35.211,
                        y: 195.237,
                        width: 183.349,
                        height: 4.372,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 63.01,
                        y: 160.852,
                        width: 103.237,
                        height: 5.961,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 63.01,
                        y: 169.697,
                        width: 155.682,
                        height: 4.372,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 35.211,
                        y: 203.185,
                        width: 85.48,
                        height: 4.372,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 35.211,
                        y: 222.659,
                        width: 58.639,
                        height: 9.141,
                        rx: 4.57
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 98.392,
                        y: 222.659,
                        width: 42.947,
                        height: 9.141,
                        rx: 4.57
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M84.545 246.5c.24.23.433.508.577.786.528 1.063.36 2.404-.577 3.283l-2.572 2.497c-1.177 1.133-3.076 1.133-4.23 0-1.177-1.133-1.177-2.96 0-4.07l1.827-1.757a3.16 3.16 0 00.072 2.104l-.769.74c-.529.509-.529 1.364 0 1.896a1.417 1.417 0 001.97 0l2.572-2.474c.265-.254.409-.6.409-.948 0-.347-.144-.693-.409-.948a1.43 1.43 0 00-.985-.393l1.298-1.248c.288.115.553.3.817.532z",
                        fill: "#FFD15C"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M80.7 250.199a3.041 3.041 0 01-.577-.786c-.529-1.064-.36-2.405.577-3.283l2.571-2.497c1.178-1.133 3.076-1.133 4.23 0 1.178 1.132 1.178 2.959 0 4.069l-1.827 1.757a3.16 3.16 0 00-.072-2.104l.77-.74c.528-.509.528-1.364 0-1.896a1.417 1.417 0 00-1.971 0l-2.548 2.497a1.323 1.323 0 00-.408.948c0 .347.144.694.408.948.265.254.625.393.986.393l-1.298 1.249a3.284 3.284 0 01-.841-.555z",
                        fill: "#FF7058"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(82.632 248.359)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.849,
                                cy: 3.717,
                                rx: 3.849,
                                ry: 3.717
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.731,
                                    y: 5.746,
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E6F1FA",
                        d: "M99.475 247.946h1.233v4.369h-1.233z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#CEE4F7",
                        d: "M100.297 247.946h.468v4.369h-.468z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M108.932 246.791l-5.059-3.19a.155.155 0 00-.162 0l-5.059 3.19v.36h10.28v-.36z",
                        fill: "#E6F1FA"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M103.927 243.6a.152.152 0 00-.161 0l-.18.115 4.826 3.076v.36h.52v-.36l-5.005-3.19z",
                        fill: "#CEE4F7"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M103.998 245.563c0 .22-.184.397-.412.397a.404.404 0 01-.41-.397c0-.22.183-.397.41-.397.228 0 .412.178.412.397z",
                        fill: "#FEDA43"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M100.97 247.946h-1.758c-.082 0-.149-.049-.149-.109v-.685h2.056v.685c0 .06-.066.109-.149.109z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M100.473 247.152v.685c0 .06-.079.109-.176.109h.646c.097 0 .176-.049.176-.109v-.685h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M100.97 252.315h-1.758c-.082 0-.149.048-.149.108v.686h2.056v-.686c0-.06-.066-.108-.149-.108z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M100.473 253.109v-.686c0-.06-.079-.108-.176-.108h.646c.097 0 .176.048.176.108v.686h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E6F1FA",
                        d: "M103.175 247.946h1.234v4.369h-1.234z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#CEE4F7",
                        d: "M103.998 247.946h.468v4.369h-.468z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M104.671 247.946h-1.758c-.082 0-.149-.049-.149-.109v-.685h2.056v.685c0 .06-.067.109-.149.109z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M104.174 247.152v.685c0 .06-.08.109-.176.109h.646c.097 0 .176-.049.176-.109v-.685h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M104.671 252.315h-1.758c-.082 0-.149.048-.149.108v.686h2.056v-.686c0-.06-.067-.108-.149-.108z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M104.174 253.109v-.686c0-.06-.08-.108-.176-.108h.646c.097 0 .176.048.176.108v.686h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#E6F1FA",
                        d: "M106.876 247.946h1.234v4.369h-1.234z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#CEE4F7",
                        d: "M107.698 247.946h.468v4.369h-.468z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M108.372 247.946h-1.758c-.083 0-.15-.049-.15-.109v-.685h2.057v.685c0 .06-.067.109-.15.109z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M107.875 247.152v.685c0 .06-.08.109-.177.109h.646c.098 0 .177-.049.177-.109v-.685h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M108.372 252.315h-1.758c-.083 0-.15.048-.15.108v.686h2.057v-.686c0-.06-.067-.108-.15-.108z",
                        fill: "#537D91"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M107.875 253.109v-.686c0-.06-.08-.108-.177-.108h.646c.098 0 .177.048.177.108v.686h-.646z",
                        fill: "#45738A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M108.794 247.549H98.379a.141.141 0 01-.138-.144v-.507c0-.08.062-.144.138-.144h10.415c.076 0 .138.065.138.144v.507c0 .08-.062.144-.138.144z",
                        fill: "#FEDA43"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M109.167 246.754h-.646c.097 0 .176.065.176.144v.507c0 .08-.079.144-.176.144h.646c.097 0 .176-.065.176-.144v-.507c0-.08-.079-.144-.176-.144z",
                        fill: "#FDB53E"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M108.932 254.3h-10.69v-1.047c0-.08.061-.144.137-.144h10.415c.076 0 .138.064.138.144v1.047z",
                        fill: "#FEDA43"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M109.167 253.109h-.646c.097 0 .176.064.176.144v1.047h.646v-1.047c0-.08-.079-.144-.176-.144z",
                        fill: "#FDB53E"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M109.204 254.697H97.97a.142.142 0 01-.14-.143v-.507c0-.08.063-.144.14-.144h11.235c.077 0 .14.065.14.144v.507c0 .079-.063.143-.14.143z",
                        fill: "#E6F1FA"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M109.578 253.903h-.646c.097 0 .176.065.176.144v.507c0 .079-.079.143-.176.143h.646c.097 0 .176-.064.176-.143v-.507c0-.08-.079-.144-.176-.144z",
                        fill: "#CEE4F7"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M103.792 246.357c.34 0 .617-.267.617-.595a.607.607 0 00-.617-.596.607.607 0 00-.617.596c0 .328.277.595.617.595zm.002-.82a.234.234 0 110 .469.234.234 0 010-.469z",
                        fill: "#000",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M109.58 253.608h-.212v-.58a.172.172 0 00-.174-.17h-.597v-.58a.172.172 0 00-.175-.17h-.211v-3.714h.211a.172.172 0 00.175-.17v-.58h.597a.172.172 0 00.174-.17v-.75a.172.172 0 00-.174-.17h-.331l-4.972-3.344a.179.179 0 00-.198 0l-4.971 3.345h-.332a.172.172 0 00-.174.17v.75c0 .093.078.169.174.169h.597v.58c0 .094.079.17.175.17h.211v3.714h-.211a.172.172 0 00-.175.17v.58h-.597a.172.172 0 00-.174.17v.58h-.211a.172.172 0 00-.175.17v.75c0 .094.078.17.175.17h11.575a.172.172 0 00.174-.17v-.75a.172.172 0 00-.174-.17zm-1.333-.692h-1.58v-.468h1.58v.468zm-1.194-.808v-3.714h.809v3.714h-.809zm1.194-3.996h-1.58v-.468h1.58v.468zm-1.754.282h.211v3.714h-.211a.172.172 0 00-.175.17v.58h-1.387v-.58a.172.172 0 00-.174-.17h-.211v-3.714h.21a.172.172 0 00.175-.17v-.58h1.387v.58c0 .094.078.17.175.17zm-3.49-.75h1.579v.468h-1.58v-.468zm.385.75h.808v3.714h-.808v-3.714zm1.194 4.054v.468h-1.58v-.468h1.58zm-6.017-5.554h3.048a.172.172 0 00.175-.17.172.172 0 00-.175-.17h-2.278l4.457-2.998 4.457 2.999h-5.937a.172.172 0 00-.175.17c0 .093.079.17.175.17h6.707v.41H98.565v-.41zm.772.75h1.58v.468h-1.58v-.468zm1.194.75v3.714h-.808v-3.714h.808zm-1.194 4.054h1.58v.468h-1.58v-.468zm1.754-.34h-.21v-3.714h.21a.172.172 0 00.175-.17v-.58h1.387v.58c0 .094.078.17.175.17h.21v3.714h-.21a.172.172 0 00-.175.17v.58h-1.387v-.58a.172.172 0 00-.175-.17zm-2.526 1.09h10.454v.468H98.565v-.468zm10.84 1.218H98.179v-.468h11.226v.468z",
                        fill: "#000",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(105.73 247.855)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.968,
                                cy: 3.686,
                                rx: 3.968,
                                ry: 3.686
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.904,
                                    y: 5.713,
                                    children: "2"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M63.226 246.615l-3.717 3.613a.955.955 0 000 1.376c.389.38 1.026.38 1.416 0l5.49-5.332c.73-.71.64-1.787-.09-2.496-.73-.71-1.836-.795-2.566-.086l-5.843 5.678a2.39 2.39 0 000 3.442 2.563 2.563 0 003.54 0l5.844-5.678",
                        strokeWidth: 0.882,
                        stroke: "#14A085",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(61.764 248.359)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.826,
                                cy: 3.717,
                                rx: 3.826,
                                ry: 3.717
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.318,
                                    y: 5.667,
                                    children: "3"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M37.35 243.354c-.05.57-.668.66-.668.66.53.023.663.692.663.692.012-.477.684-.7.684-.7-.504-.029-.679-.652-.679-.652z",
                        fill: "#D7E057"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M38.033 243.933c-.441-.026-.607-.592-.608-.598a.077.077 0 00-.082-.054.075.075 0 00-.07.067c-.044.503-.58.589-.603.592a.075.075 0 00-.065.077.075.075 0 00.073.07c.464.021.59.626.592.632a.076.076 0 00.082.06.075.075 0 00.07-.072c.01-.419.626-.629.632-.63a.074.074 0 00.05-.08.076.076 0 00-.07-.064zm-.696.509c-.07-.154-.19-.34-.39-.437a.81.81 0 00.422-.407c.08.15.215.338.427.43-.154.08-.355.216-.459.414z",
                        fill: "#3A312A",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M36.237 244.19c-.035.403-.473.466-.473.466.376.017.47.49.47.49.007-.337.483-.495.483-.495-.356-.02-.48-.46-.48-.46z",
                        fill: "#D7E057"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M36.721 244.578c-.296-.017-.409-.403-.41-.407a.078.078 0 00-.08-.054.075.075 0 00-.07.067c-.03.338-.393.397-.408.4a.075.075 0 00-.066.076.075.075 0 00.074.07c.31.014.396.426.397.43a.076.076 0 00.082.06.075.075 0 00.07-.072c.007-.281.428-.425.432-.427a.074.074 0 00.051-.08.076.076 0 00-.072-.063zm-.491.334a.64.64 0 00-.229-.26.602.602 0 00.25-.242.67.67 0 00.254.258.792.792 0 00-.275.244z",
                        fill: "#3A312A",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M36.237 242.878c-.035.402-.473.466-.473.466.376.017.47.49.47.49.007-.338.483-.495.483-.495-.356-.02-.48-.461-.48-.461z",
                        fill: "#D7E057"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M36.721 243.265c-.296-.017-.409-.403-.41-.407a.078.078 0 00-.08-.054.075.075 0 00-.07.067c-.03.339-.393.398-.408.4a.075.075 0 00-.066.077.075.075 0 00.074.07c.31.014.396.425.397.43a.076.076 0 00.082.06.075.075 0 00.07-.073c.007-.28.428-.425.432-.426a.074.074 0 00.051-.08.076.076 0 00-.072-.064zm-.491.335a.639.639 0 00-.229-.26.602.602 0 00.25-.242.671.671 0 00.254.257.792.792 0 00-.275.245z",
                        fill: "#3A312A",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M46.693 242.857h-7.555a.497.497 0 00-.507.486v9.124c0 .38-.16.723-.42.973-.19.18-.43.312-.701.369l-.022.033h8.57c.63 0 1.142-.49 1.142-1.096v-9.403a.497.497 0 00-.507-.486z",
                        fill: "#FCE8CB"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M46.693 242.783H44.8a.075.075 0 00-.077.074c0 .04.034.074.077.074h1.894c.237 0 .43.185.43.412v9.403c0 .564-.478 1.022-1.066 1.022h-8.195c.148-.07.285-.162.404-.276.285-.274.442-.638.442-1.025v-9.124c0-.227.193-.412.43-.412h4.877a.075.075 0 00.077-.074.075.075 0 00-.077-.074h-4.877a.573.573 0 00-.584.56v9.124c0 .347-.141.674-.397.92a1.368 1.368 0 01-.664.35.077.077 0 00-.049.033l-.021.034a.071.071 0 00-.002.074c.014.024.04.038.067.038h8.57c.672 0 1.22-.525 1.22-1.17v-9.403a.573.573 0 00-.585-.56z",
                        fill: "#3A312A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M36.271 245.745a.497.497 0 00-.507.486v6.236c0 .76.642 1.375 1.434 1.375.791 0 1.433-.616 1.433-1.375v-6.722h-2.36z",
                        fill: "#87796F"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M38.63 245.67h-2.359a.573.573 0 00-.584.561v2.438c0 .04.035.074.077.074a.076.076 0 00.077-.074v-2.438c0-.228.193-.413.43-.413h2.283v6.649c0 .718-.609 1.301-1.357 1.301-.747 0-1.356-.583-1.356-1.301v-3.02a.075.075 0 00-.077-.075.075.075 0 00-.077.074v3.021c0 .799.678 1.45 1.51 1.45.833 0 1.51-.65 1.51-1.45v-6.723a.075.075 0 00-.076-.073z",
                        fill: "#3A312A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M45.595 246.09h-5.368a.404.404 0 00-.412.394v1.691c0 .218.184.395.412.395h5.368a.404.404 0 00.411-.395v-1.69a.404.404 0 00-.411-.396z",
                        fill: "#F16C7A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M45.595 246.015h-5.368a.48.48 0 00-.49.47v1.69c0 .259.22.469.49.469h5.368a.48.48 0 00.488-.469v-1.69a.48.48 0 00-.488-.47zm.334 2.16c0 .177-.15.321-.334.321h-5.368a.329.329 0 01-.335-.32v-1.692c0-.177.15-.321.335-.321h5.368c.184 0 .334.144.334.321v1.691z",
                        fill: "#3A312A",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M45.662 243.834H40.16a.337.337 0 00-.344.33v.492c0 .182.154.33.344.33h5.503c.19 0 .344-.148.344-.33v-.492a.337.337 0 00-.344-.33z",
                        fill: "#8AC6DD"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        fill: "#3A312A",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M45.662 243.76H40.16a.413.413 0 00-.421.404v.492c0 .223.189.404.421.404h5.503a.413.413 0 00.421-.404v-.492a.413.413 0 00-.42-.404zm.267.896c0 .141-.12.256-.267.256H40.16a.262.262 0 01-.267-.256v-.492c0-.142.12-.257.267-.257h5.503c.148 0 .267.115.267.257v.492z",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M46.006 249.473h-6.191a.075.075 0 00-.077.074c0 .041.034.074.077.074h6.191a.075.075 0 00.077-.074.075.075 0 00-.077-.074zM46.006 250.505h-6.191a.075.075 0 00-.077.074c0 .04.034.074.077.074h6.191a.075.075 0 00.077-.074.075.075 0 00-.077-.074zM46.006 251.537h-6.191a.075.075 0 00-.077.074c0 .04.034.074.077.074h6.191a.076.076 0 00.077-.074.075.075 0 00-.077-.074zM46.006 252.569h-6.191a.075.075 0 00-.077.073c0 .041.034.074.077.074h6.191a.075.075 0 00.077-.074.075.075 0 00-.077-.073z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M46.693 242.93h-.709c.237 0 .43.186.43.413v9.403c0 .564-.478 1.022-1.065 1.022h.708c.588 0 1.066-.458 1.066-1.022v-9.403a.422.422 0 00-.43-.412z",
                        fill: "#DECAAD"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(41.482 248.359)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.865,
                                cy: 3.717,
                                rx: 3.865,
                                ry: 3.717
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.299,
                                    y: 5.667,
                                    children: "5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        transform: "translate(254.826 146.536)",
                        fill: "#FFF",
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: 1.17,
                            y: 1.17,
                            width: 215.842,
                            height: 118.966,
                            rx: 4.633
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 264.765,
                        y: 188.022,
                        width: 183.349,
                        height: 4.543,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 285.404,
                        y: 159.591,
                        width: 139.99,
                        height: 7.021,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 285.404,
                        y: 169.7,
                        width: 101.585,
                        height: 4.543,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 264.765,
                        y: 195.456,
                        width: 85.48,
                        height: 4.543,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 264.765,
                        y: 223.952,
                        width: 58.639,
                        height: 9.499,
                        rx: 4.749
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 327.946,
                        y: 223.952,
                        width: 42.947,
                        height: 9.499,
                        rx: 4.749
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 375.435,
                        y: 223.952,
                        width: 49.967,
                        height: 9.499,
                        rx: 4.749
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M335.94 248.235c.243.244.437.536.583.829.533 1.12.364 2.534-.582 3.46l-2.596 2.632c-1.188 1.194-3.104 1.194-4.268 0-1.189-1.194-1.189-3.12 0-4.289l1.843-1.852a3.47 3.47 0 00.073 2.218l-.776.78c-.534.536-.534 1.437 0 1.998.557.56 1.43.56 1.988 0l2.596-2.608c.266-.268.412-.633.412-.999a1.412 1.412 0 00-1.407-1.413l1.31-1.316c.291.122.558.317.825.56z",
                                fill: "#FFD15C"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M332.06 252.134a3.202 3.202 0 01-.582-.828c-.534-1.121-.364-2.535.582-3.46l2.595-2.632c1.189-1.195 3.105-1.195 4.269 0 1.188 1.194 1.188 3.119 0 4.289l-1.843 1.852a3.47 3.47 0 00-.073-2.218l.776-.78c.534-.536.534-1.438 0-1.998a1.386 1.386 0 00-1.989 0l-2.57 2.632a1.425 1.425 0 00-.413.999 1.412 1.412 0 001.407 1.413l-1.31 1.316a3.306 3.306 0 01-.85-.585z",
                                fill: "#FF7058"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(334.01 250.195)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.884,
                                        cy: 3.918,
                                        rx: 3.884,
                                        ry: 3.918
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.428,
                                            y: 5.96,
                                            children: "5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M351.008 249.76h1.245v4.604h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M351.838 249.76h.468v4.604h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.552 248.543l-5.105-3.363a.15.15 0 00-.164 0l-5.105 3.363v.38h10.374v-.38z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M355.501 245.18a.148.148 0 00-.163 0l-.18.12 4.87 3.243v.38h.524v-.38l-5.05-3.363z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M355.573 247.248a.417.417 0 01-.415.419.417.417 0 01-.415-.419c0-.231.185-.418.415-.418.229 0 .415.187.415.418z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M352.517 249.76h-1.774c-.083 0-.15-.051-.15-.115v-.722h2.075v.722c0 .064-.068.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M352.016 248.923v.722c0 .064-.08.115-.178.115h.652c.098 0 .178-.051.178-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M352.517 254.364h-1.774c-.083 0-.15.052-.15.115v.723h2.075v-.723c0-.063-.068-.115-.15-.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M352.016 255.202v-.723c0-.063-.08-.115-.178-.115h.652c.098 0 .178.052.178.115v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M354.743 249.76h1.245v4.604h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M355.573 249.76h.468v4.604h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M356.252 249.76h-1.774c-.083 0-.15-.051-.15-.115v-.722h2.074v.722c0 .064-.067.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M355.75 248.923v.722c0 .064-.08.115-.177.115h.652c.098 0 .177-.051.177-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M356.252 254.364h-1.774c-.083 0-.15.052-.15.115v.723h2.074v-.723c0-.063-.067-.115-.15-.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M355.75 255.202v-.723c0-.063-.08-.115-.177-.115h.652c.098 0 .177.052.177.115v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M358.477 249.76h1.245v4.604h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M359.307 249.76h.468v4.604h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M359.987 249.76h-1.774c-.083 0-.15-.051-.15-.115v-.722h2.074v.722c0 .064-.067.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M359.485 248.923v.722c0 .064-.08.115-.178.115h.652c.099 0 .178-.051.178-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M359.987 254.364h-1.774c-.083 0-.15.052-.15.115v.723h2.074v-.723c0-.063-.067-.115-.15-.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M359.485 255.202v-.723c0-.063-.08-.115-.178-.115h.652c.099 0 .178.052.178.115v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.413 249.341h-10.51c-.078 0-.14-.068-.14-.151v-.534c0-.084.062-.152.14-.152h10.51c.077 0 .14.068.14.152v.534c0 .083-.063.151-.14.151z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.79 248.504h-.653c.098 0 .178.068.178.152v.534c0 .083-.08.151-.178.151h.652c.099 0 .178-.068.178-.151v-.534c0-.084-.08-.152-.178-.152z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.552 256.457h-10.79v-1.104c0-.083.063-.151.14-.151h10.51c.078 0 .14.068.14.151v1.104z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.79 255.202h-.653c.098 0 .178.068.178.151v1.104h.652v-1.104c0-.083-.08-.151-.178-.151z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M360.827 256.876h-11.339c-.077 0-.14-.068-.14-.152v-.534c0-.083.063-.151.14-.151h11.339c.077 0 .14.068.14.151v.534c0 .084-.063.152-.14.152z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M361.204 256.039h-.652c.098 0 .178.068.178.151v.534c0 .084-.08.152-.178.152h.652c.099 0 .178-.068.178-.152v-.534c0-.083-.08-.151-.178-.151z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M355.365 248.085a.626.626 0 00.623-.627.626.626 0 00-.623-.628.626.626 0 00-.622.628c0 .346.279.627.622.627zm0-.864c.13 0 .235.106.235.237 0 .13-.106.236-.235.236a.236.236 0 01-.234-.236c0-.13.105-.237.234-.237z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M361.206 255.728h-.213v-.611a.178.178 0 00-.176-.18h-.603v-.61a.178.178 0 00-.176-.18h-.213v-3.915h.213c.097 0 .176-.08.176-.179v-.611h.603c.097 0 .176-.08.176-.18v-.79a.178.178 0 00-.176-.179h-.335l-5.017-3.525a.174.174 0 00-.2 0l-5.017 3.525h-.334a.178.178 0 00-.177.18v.79c0 .098.08.179.177.179h.602v.611c0 .099.079.179.176.179h.213v3.915h-.213a.178.178 0 00-.176.18v.61h-.602a.178.178 0 00-.177.18v.611h-.213a.178.178 0 00-.176.179v.79c0 .099.079.18.176.18h11.682c.097 0 .176-.081.176-.18v-.79a.178.178 0 00-.176-.179zm-1.345-.755h-1.594v-.468h1.594v.468zm-1.205-.826v-3.915h.816v3.915h-.816zm1.205-4.237h-1.594v-.468h1.594v.468zm-1.77.322h.213v3.915h-.213a.178.178 0 00-.176.18v.61h-1.4v-.61a.178.178 0 00-.176-.18h-.214v-3.915h.214c.097 0 .176-.08.176-.179v-.611h1.4v.611c0 .099.078.179.176.179zm-3.523-.79h1.594v.468h-1.594v-.468zm.39.79h.815v3.915h-.816v-3.915zm1.204 4.273v.468h-1.594v-.468h1.594zm-6.072-5.854h3.076c.098 0 .176-.08.176-.179a.178.178 0 00-.176-.179h-2.299l4.498-3.16 4.498 3.16h-5.992a.178.178 0 00-.176.18c0 .098.079.178.176.178h6.769v.433h-10.55v-.433zm.779.79h1.594v.469h-1.594v-.468zm1.205.791v3.915h-.816v-3.915h.816zm-1.205 4.273h1.594v.468h-1.594v-.468zm1.77-.358h-.213v-3.915h.213c.098 0 .177-.08.177-.179v-.611h1.4v.611c0 .099.078.179.176.179h.213v3.915h-.213a.178.178 0 00-.177.18v.61h-1.4v-.61a.178.178 0 00-.176-.18zm-2.55 1.148h10.551v.468h-10.55v-.468zm10.94 1.259h-11.328v-.468h11.329v.468z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(357.528 249.853)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.73,
                                cy: 3.863,
                                rx: 3.73,
                                ry: 3.863
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.73,
                                    y: 5.901,
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M314.64 248.357l-3.77 3.809a1.034 1.034 0 000 1.45c.394.4 1.04.4 1.436 0l5.568-5.62c.74-.749.65-1.883-.091-2.632-.74-.748-1.862-.837-2.603-.09l-5.926 5.985a2.588 2.588 0 000 3.627 2.529 2.529 0 003.59 0l5.928-5.984",
                                strokeWidth: 0.882,
                                stroke: "#14A085",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(313.156 250.195)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.88,
                                        cy: 3.918,
                                        rx: 3.88,
                                        ry: 3.918
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.425,
                                            y: 5.96,
                                            children: "2"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M289.167 244.92c-.05.6-.676.695-.676.695.537.025.67.73.67.73.012-.503.692-.738.692-.738-.509-.03-.686-.687-.686-.687z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M289.858 245.53c-.447-.027-.614-.624-.616-.63a.078.078 0 00-.153.014c-.044.53-.586.62-.61.624a.078.078 0 00.009.155c.468.022.596.66.598.666a.078.078 0 00.154-.013c.01-.441.632-.663.639-.665a.078.078 0 00-.021-.151zm-.704.537c-.07-.163-.193-.359-.394-.461a.835.835 0 00.426-.43c.08.16.218.358.432.453-.156.085-.359.229-.464.438z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.041 245.801c-.035.425-.478.492-.478.492.38.018.475.516.475.516.008-.355.489-.522.489-.522-.36-.021-.486-.486-.486-.486z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.531 246.21c-.3-.018-.414-.425-.415-.43a.078.078 0 00-.153.014c-.03.357-.396.42-.411.422a.078.078 0 00.008.155c.313.014.4.448.401.452a.078.078 0 00.155-.013c.006-.296.432-.448.436-.449a.078.078 0 00-.02-.151zm-.497.352a.667.667 0 00-.23-.274.62.62 0 00.252-.255.694.694 0 00.256.271.813.813 0 00-.278.258z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.041 244.418c-.035.424-.478.491-.478.491.38.018.475.516.475.516.008-.355.489-.521.489-.521-.36-.021-.486-.486-.486-.486z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.531 244.826c-.3-.018-.414-.424-.415-.429a.078.078 0 00-.153.014c-.03.357-.396.419-.411.421a.078.078 0 00.008.155c.313.015.4.449.401.453a.078.078 0 00.155-.013c.006-.296.432-.448.436-.45a.078.078 0 00-.02-.15zm-.497.353a.666.666 0 00-.23-.274.621.621 0 00.252-.255.695.695 0 00.256.271.813.813 0 00-.278.258z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 244.396h-7.64a.513.513 0 00-.513.513v9.616a1.447 1.447 0 01-1.134 1.414l-.021.036h8.665c.638 0 1.156-.518 1.156-1.156v-9.91a.513.513 0 00-.513-.513z",
                                fill: "#FCE8CB"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 244.318h-1.916a.078.078 0 000 .156h1.916c.24 0 .435.195.435.435v9.91c0 .594-.484 1.078-1.078 1.078h-8.287a1.53 1.53 0 00.855-1.372v-9.616c0-.24.195-.435.435-.435h4.932a.078.078 0 000-.156h-4.932a.591.591 0 00-.59.59v9.617a1.365 1.365 0 01-1.073 1.339.078.078 0 00-.05.035l-.022.035a.078.078 0 00.067.119h8.665c.68 0 1.233-.554 1.233-1.234v-9.91a.591.591 0 00-.59-.591z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.076 247.44a.513.513 0 00-.513.512v6.573a1.45 1.45 0 102.9 0v-7.085h-2.387z",
                                fill: "#87796F"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M290.462 247.362h-2.386a.591.591 0 00-.59.59v2.57a.078.078 0 00.155 0v-2.57c0-.24.195-.435.435-.435h2.308v7.008c0 .756-.615 1.372-1.371 1.372a1.373 1.373 0 01-1.372-1.372v-3.184a.078.078 0 00-.156 0v3.184a1.53 1.53 0 001.528 1.528 1.53 1.53 0 001.527-1.528v-7.085a.078.078 0 00-.078-.078z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.504 247.803h-5.428a.416.416 0 00-.417.416v1.782c0 .23.187.417.417.417h5.428c.23 0 .416-.187.416-.417v-1.782a.416.416 0 00-.416-.416z",
                                fill: "#F16C7A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.504 247.725h-5.428a.495.495 0 00-.494.494v1.782c0 .273.221.495.494.495h5.428a.495.495 0 00.494-.495v-1.782a.495.495 0 00-.494-.494zm.339 2.276a.339.339 0 01-.339.34h-5.428a.339.339 0 01-.339-.34v-1.782c0-.187.152-.338.339-.338h5.428c.187 0 .339.152.339.338v1.782z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.572 245.425h-5.565a.348.348 0 00-.348.348v.519c0 .192.156.348.348.348h5.565a.348.348 0 00.348-.348v-.519a.348.348 0 00-.348-.348z",
                                fill: "#8AC6DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#3A312A",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M297.572 245.348h-5.565a.426.426 0 00-.426.425v.519c0 .235.191.426.426.426h5.565a.426.426 0 00.426-.426v-.519a.426.426 0 00-.426-.425zm.27.944a.27.27 0 01-.27.27h-5.565a.27.27 0 01-.27-.27v-.519a.27.27 0 01.27-.27h5.565c.15 0 .27.122.27.27v.519z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M297.92 251.37h-6.26a.078.078 0 000 .156h6.26a.078.078 0 000-.156zM297.92 252.457h-6.26a.078.078 0 000 .156h6.26a.078.078 0 000-.156zM297.92 253.545h-6.26a.078.078 0 000 .155h6.26a.078.078 0 000-.155zM297.92 254.632h-6.26a.078.078 0 000 .156h6.26a.078.078 0 000-.156z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 244.474h-.717c.24 0 .435.195.435.435v9.91c0 .594-.483 1.078-1.077 1.078h.716a1.08 1.08 0 001.078-1.078v-9.91a.435.435 0 00-.435-.435z",
                                fill: "#DECAAD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(293.345 250.195)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.918,
                                        rx: 3.909,
                                        ry: 3.918
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.443,
                                            y: 5.96,
                                            children: "9"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#D3E6F8",
                                d: "M277.208 253.034l-5.633 2.84-5.634-2.84v-5.678l5.634-2.839 5.633 2.84z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FFF",
                                d: "M265.941 247.366l5.454 2.742 5.748-2.778-5.575-2.813-5.627 2.84z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#A4CFF2",
                                d: "M277.208 253.034v-5.574l-5.595 2.742v5.643z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FD919E",
                                d: "M267.168 249.218v3.212l3.065 1.542v-3.225z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#4C4372",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.575 256.072a.257.257 0 01-.116-.027l-5.633-2.839a.196.196 0 01-.115-.172v-5.678c0-.07.044-.136.115-.172l5.633-2.839a.261.261 0 01.231 0l5.633 2.839c.071.036.115.101.115.172v5.678c0 .071-.044.137-.115.172l-5.633 2.84a.257.257 0 01-.115.026zm-5.404-3.152l5.404 2.723 5.403-2.723v-5.45l-5.403-2.722-5.404 2.723v5.449z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.575 250.394a.256.256 0 01-.116-.027l-5.54-2.787c-.11-.055-.147-.177-.083-.272.064-.095.204-.127.314-.072l5.425 2.729 5.388-2.711c.11-.056.25-.023.314.072s.027.217-.083.272l-5.504 2.77a.26.26 0 01-.115.026z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.575 255.94c-.127 0-.23-.09-.23-.2v-5.545c0-.11.103-.2.23-.2.126 0 .23.09.23.2v5.545c0 .11-.104.2-.23.2zM274.45 248.927a.258.258 0 01-.113-.026l-5.658-2.806c-.11-.055-.149-.177-.086-.272.063-.096.204-.129.314-.074l5.658 2.806c.11.055.149.176.086.272a.238.238 0 01-.2.1z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M270.233 254.17a.256.256 0 01-.115-.026l-3.066-1.542a.196.196 0 01-.114-.172v-3.212c0-.07.043-.137.114-.172a.26.26 0 01.23 0l3.066 1.529a.196.196 0 01.115.172v3.225a.196.196 0 01-.115.172.256.256 0 01-.115.027zm-2.835-1.855l2.605 1.31v-2.762l-2.605-1.3v2.752z",
                                        fillRule: "nonzero"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(271.575 250.195)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.918,
                                        rx: 3.909,
                                        ry: 3.918
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.932,
                                            y: 5.96,
                                            children: "1"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        transform: "translate(25.272 282.162)",
                        fill: "#FFF",
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: 1.17,
                            y: 1.17,
                            width: 215.842,
                            height: 119.808,
                            rx: 4.633
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 35.211,
                        y: 323.621,
                        width: 183.349,
                        height: 4.54,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 63.209,
                        y: 295.118,
                        width: 139.99,
                        height: 7.016,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 63.209,
                        y: 305.023,
                        width: 101.585,
                        height: 4.54,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 35.211,
                        y: 331.05,
                        width: 85.48,
                        height: 4.54,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 35.211,
                        y: 359.528,
                        width: 58.639,
                        height: 9.493,
                        rx: 4.746
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 98.392,
                        y: 359.528,
                        width: 42.947,
                        height: 9.493,
                        rx: 4.746
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 145.881,
                        y: 359.528,
                        width: 49.967,
                        height: 9.493,
                        rx: 4.746
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M106.387 384.256a3.2 3.2 0 01.582.828c.533 1.12.364 2.533-.582 3.458l-2.596 2.63c-1.188 1.194-3.104 1.194-4.268 0-1.189-1.193-1.189-3.117 0-4.286l1.843-1.85c-.218.73-.194 1.51.073 2.216l-.776.779c-.534.536-.534 1.437 0 1.997.557.56 1.43.56 1.988 0l2.596-2.606c.266-.268.412-.633.412-.998a1.412 1.412 0 00-1.407-1.412l1.31-1.316c.291.122.558.317.825.56z",
                                fill: "#FFD15C"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M102.506 388.153a3.2 3.2 0 01-.582-.828c-.534-1.12-.364-2.533.582-3.459l2.595-2.63c1.189-1.193 3.105-1.193 4.269 0 1.188 1.194 1.188 3.117 0 4.286l-1.843 1.851c.218-.73.194-1.51-.073-2.216l.776-.78c.534-.535.534-1.436 0-1.996a1.387 1.387 0 00-1.989 0l-2.57 2.63a1.424 1.424 0 00-.413.998 1.412 1.412 0 001.407 1.412l-1.31 1.316a3.306 3.306 0 01-.85-.584z",
                                fill: "#FF7058"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(104.456 386.215)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.884,
                                        cy: 3.916,
                                        rx: 3.884,
                                        ry: 3.916
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.428,
                                            y: 5.957,
                                            children: "5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M121.454 385.78h1.245v4.601h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M122.284 385.78h.468v4.601h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M130.998 384.563l-5.105-3.36a.15.15 0 00-.164 0l-5.105 3.36v.38h10.374v-.38z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M125.947 381.202a.148.148 0 00-.163 0l-.18.12 4.87 3.241v.38h.524v-.38l-5.05-3.36z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M126.019 383.27a.417.417 0 01-.415.418.417.417 0 01-.415-.418c0-.231.185-.419.415-.419.229 0 .415.188.415.419z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M122.963 385.78h-1.774c-.083 0-.15-.052-.15-.115v-.722h2.075v.722c0 .063-.068.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M122.462 384.943v.722c0 .063-.08.115-.178.115h.652c.098 0 .178-.052.178-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M122.963 390.381h-1.774c-.083 0-.15.051-.15.114v.723h2.075v-.723c0-.063-.068-.114-.15-.114z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M122.462 391.218v-.723c0-.063-.08-.114-.178-.114h.652c.098 0 .178.051.178.114v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M125.189 385.78h1.245v4.601h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M126.019 385.78h.468v4.601h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M126.698 385.78h-1.774c-.083 0-.15-.052-.15-.115v-.722h2.074v.722c0 .063-.067.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M126.196 384.943v.722c0 .063-.08.115-.177.115h.652c.098 0 .177-.052.177-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M126.698 390.381h-1.774c-.083 0-.15.051-.15.114v.723h2.074v-.723c0-.063-.067-.114-.15-.114z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M126.196 391.218v-.723c0-.063-.08-.114-.177-.114h.652c.098 0 .177.051.177.114v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M128.923 385.78h1.245v4.601h-1.245z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M129.753 385.78h.468v4.601h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M130.433 385.78h-1.774c-.083 0-.15-.052-.15-.115v-.722h2.074v.722c0 .063-.067.115-.15.115z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M129.931 384.943v.722c0 .063-.08.115-.178.115h.652c.099 0 .178-.052.178-.115v-.722h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M130.433 390.381h-1.774c-.083 0-.15.051-.15.114v.723h2.074v-.723c0-.063-.067-.114-.15-.114z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M129.931 391.218v-.723c0-.063-.08-.114-.178-.114h.652c.099 0 .178.051.178.114v.723h-.652z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M130.859 385.361h-10.51c-.078 0-.14-.068-.14-.151v-.534c0-.084.062-.151.14-.151h10.51c.077 0 .14.067.14.151v.534c0 .083-.063.151-.14.151z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M131.235 384.525h-.652c.098 0 .178.067.178.151v.534c0 .083-.08.151-.178.151h.652c.099 0 .178-.068.178-.151v-.534c0-.084-.08-.151-.178-.151z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M130.998 392.473h-10.79v-1.104c0-.083.063-.151.14-.151h10.51c.078 0 .14.068.14.151v1.104z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M131.235 391.218h-.652c.098 0 .178.068.178.151v1.104h.652v-1.104c0-.083-.08-.151-.178-.151z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M131.273 392.891h-11.339c-.077 0-.14-.068-.14-.151v-.534c0-.084.063-.152.14-.152h11.339c.077 0 .14.068.14.152v.534c0 .083-.063.151-.14.151z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M131.65 392.054h-.652c.098 0 .178.068.178.152v.534c0 .083-.08.151-.178.151h.652c.099 0 .178-.068.178-.151v-.534c0-.084-.08-.152-.178-.152z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M125.811 384.106a.626.626 0 00.623-.627.626.626 0 00-.623-.628.626.626 0 00-.622.628c0 .346.279.627.622.627zm0-.864c.13 0 .235.106.235.237 0 .13-.106.236-.235.236a.236.236 0 01-.234-.236c0-.13.105-.237.234-.237z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M131.652 391.744h-.213v-.611a.178.178 0 00-.176-.18h-.603v-.61a.178.178 0 00-.176-.179h-.213v-3.913h.213c.097 0 .176-.08.176-.178v-.611h.603c.097 0 .176-.08.176-.18v-.79a.178.178 0 00-.176-.178h-.335l-5.017-3.523a.174.174 0 00-.2 0l-5.017 3.523h-.334a.178.178 0 00-.177.179v.79c0 .098.08.179.177.179h.602v.61c0 .1.079.18.176.18h.213v3.912h-.213a.178.178 0 00-.176.179v.61h-.602a.178.178 0 00-.177.18v.61h-.213a.177.177 0 00-.176.18v.79c0 .098.079.178.176.178h11.682c.097 0 .176-.08.176-.179v-.79a.178.178 0 00-.176-.178zm-1.345-.754h-1.594v-.468h1.594v.468zm-1.205-.826v-3.913h.816v3.913h-.816zm1.205-4.234h-1.594v-.468h1.594v.468zm-1.77.321h.213v3.913h-.213a.177.177 0 00-.176.179v.61h-1.4v-.61a.178.178 0 00-.176-.179h-.214v-3.913h.214c.097 0 .176-.08.176-.178v-.611h1.4v.61c0 .1.078.18.176.18zm-3.523-.79h1.594v.469h-1.594v-.468zm.39.79h.815v3.913h-.816v-3.913zm1.204 4.27v.469h-1.594v-.468h1.594zm-6.072-5.85h3.076c.098 0 .176-.08.176-.178a.177.177 0 00-.176-.179h-2.299l4.498-3.158 4.498 3.158h-5.992a.178.178 0 00-.176.179c0 .099.079.179.176.179h6.769v.432h-10.55v-.432zm.779.79h1.594v.469h-1.594v-.468zm1.205.79v3.913h-.816v-3.913h.816zm-1.205 4.27h1.594v.469h-1.594v-.468zm1.77-.357h-.213v-3.913h.213c.098 0 .177-.08.177-.178v-.611h1.4v.61c0 .1.078.18.176.18h.213v3.912h-.213a.177.177 0 00-.177.179v.61h-1.4v-.61a.178.178 0 00-.176-.179zm-2.55 1.147h10.551v.468h-10.55v-.468zm10.94 1.258h-11.328v-.468h11.329v.468z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(127.974 385.872)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.73,
                                cy: 3.86,
                                rx: 3.73,
                                ry: 3.86
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.73,
                                    y: 5.898,
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M85.086 384.377l-3.77 3.807a1.033 1.033 0 000 1.45c.394.399 1.04.399 1.436 0l5.568-5.618c.74-.748.65-1.881-.091-2.629-.74-.747-1.862-.837-2.603-.09l-5.926 5.98a2.585 2.585 0 000 3.626 2.53 2.53 0 003.59 0l5.928-5.98",
                                strokeWidth: 0.882,
                                stroke: "#14A085",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(83.602 386.215)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.88,
                                        cy: 3.916,
                                        rx: 3.88,
                                        ry: 3.916
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.425,
                                            y: 5.957,
                                            children: "2"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M59.613 380.943c-.05.6-.676.694-.676.694.537.026.67.73.67.73.012-.502.692-.737.692-.737-.509-.03-.686-.687-.686-.687z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M60.304 381.552c-.447-.026-.614-.623-.616-.63a.078.078 0 00-.153.014c-.044.53-.586.62-.61.624a.078.078 0 00.009.155c.468.022.596.66.598.666a.078.078 0 00.154-.013c.01-.441.632-.662.639-.665a.078.078 0 00-.021-.15zm-.704.537c-.07-.163-.193-.359-.394-.46a.835.835 0 00.426-.43c.08.16.218.357.432.453-.156.085-.359.228-.464.437z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M58.487 381.823c-.035.425-.478.492-.478.492.38.018.475.515.475.515.008-.355.489-.52.489-.52-.36-.022-.486-.487-.486-.487z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M58.977 382.232c-.3-.018-.414-.425-.415-.429a.078.078 0 00-.153.014c-.03.356-.396.418-.411.42a.078.078 0 00.008.155c.313.015.4.449.401.453a.078.078 0 00.155-.013c.006-.296.432-.448.436-.449a.078.078 0 00-.02-.151zm-.497.352a.667.667 0 00-.23-.274.62.62 0 00.252-.255.694.694 0 00.256.271.812.812 0 00-.278.258z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M58.487 380.441c-.035.424-.478.491-.478.491.38.018.475.516.475.516.008-.355.489-.521.489-.521-.36-.022-.486-.486-.486-.486z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M58.977 380.85c-.3-.019-.414-.425-.415-.43a.078.078 0 00-.153.014c-.03.357-.396.419-.411.421a.078.078 0 00.008.155c.313.015.4.448.401.452a.078.078 0 00.155-.012c.006-.296.432-.448.436-.45a.078.078 0 00-.02-.15zm-.497.352a.665.665 0 00-.23-.274.621.621 0 00.252-.255.694.694 0 00.256.27.813.813 0 00-.278.259z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M69.061 380.419h-7.64a.513.513 0 00-.513.512v9.61a1.445 1.445 0 01-1.134 1.414l-.021.035h8.665c.638 0 1.156-.517 1.156-1.155v-9.904a.512.512 0 00-.513-.512z",
                                fill: "#FCE8CB"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M69.061 380.341h-1.916a.078.078 0 000 .156h1.916c.24 0 .435.195.435.434v9.904c0 .594-.484 1.078-1.078 1.078h-8.287a1.53 1.53 0 00.855-1.371v-9.61c0-.24.195-.435.435-.435h4.932a.078.078 0 000-.156H61.42a.591.591 0 00-.59.59v9.61a1.363 1.363 0 01-1.073 1.338.078.078 0 00-.05.035l-.022.036a.078.078 0 00.067.118h8.665c.68 0 1.233-.553 1.233-1.232v-9.905a.59.59 0 00-.59-.59z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M58.522 383.46a.513.513 0 00-.513.513v6.569a1.45 1.45 0 002.9 0v-7.081h-2.387z",
                                fill: "#87796F"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M60.908 383.383h-2.386a.591.591 0 00-.59.59v2.568a.078.078 0 00.155 0v-2.568c0-.24.195-.434.435-.434h2.308v7.003c0 .756-.615 1.37-1.371 1.37a1.373 1.373 0 01-1.372-1.37v-3.182a.078.078 0 00-.156 0v3.182a1.529 1.529 0 003.055 0v-7.081a.078.078 0 00-.078-.078z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M67.95 383.824h-5.428a.416.416 0 00-.417.416v1.781c0 .23.187.416.417.416h5.428c.23 0 .416-.186.416-.416v-1.781a.416.416 0 00-.416-.416z",
                                fill: "#F16C7A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M67.95 383.746h-5.428a.495.495 0 00-.494.494v1.781c0 .272.221.494.494.494h5.428a.495.495 0 00.494-.494v-1.781a.495.495 0 00-.494-.494zm.339 2.275a.339.339 0 01-.339.338h-5.428a.339.339 0 01-.339-.338v-1.781c0-.187.152-.338.339-.338h5.428c.187 0 .339.151.339.338v1.781z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M68.018 381.448h-5.565a.348.348 0 00-.348.348v.518c0 .192.156.348.348.348h5.565a.348.348 0 00.348-.348v-.518a.348.348 0 00-.348-.348z",
                                fill: "#8AC6DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#3A312A",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M68.018 381.37h-5.565a.426.426 0 00-.426.426v.518c0 .235.191.426.426.426h5.565c.235 0 .426-.191.426-.426v-.518a.426.426 0 00-.426-.426zm.27.944a.27.27 0 01-.27.27h-5.565a.27.27 0 01-.27-.27v-.518a.27.27 0 01.27-.27h5.565c.15 0 .27.12.27.27v.518z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M68.366 387.389h-6.26a.078.078 0 000 .155h6.26a.078.078 0 000-.155zM68.366 388.475h-6.26a.078.078 0 000 .156h6.26a.078.078 0 000-.156zM68.366 389.562h-6.26a.078.078 0 000 .156h6.26a.078.078 0 000-.156zM68.366 390.649h-6.26a.078.078 0 000 .155h6.26a.078.078 0 000-.155z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M69.061 380.497h-.717c.24 0 .435.195.435.434v9.904c0 .594-.483 1.078-1.077 1.078h.716c.594 0 1.078-.484 1.078-1.078v-9.904a.435.435 0 00-.435-.434z",
                                fill: "#DECAAD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(63.791 386.215)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.916,
                                        rx: 3.909,
                                        ry: 3.916
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.443,
                                            y: 5.957,
                                            children: "9"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#D3E6F8",
                                d: "M47.654 389.052l-5.633 2.837-5.634-2.837v-5.675l5.634-2.837 5.633 2.837z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FFF",
                                d: "M36.387 383.387l5.454 2.74 5.748-2.776-5.575-2.81-5.627 2.836z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#A4CFF2",
                                d: "M47.654 389.052v-5.57l-5.595 2.74v5.639z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FD919E",
                                d: "M37.614 385.238v3.21l3.065 1.54v-3.221z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#4C4372",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M42.02 392.088a.257.257 0 01-.115-.027l-5.633-2.837a.196.196 0 01-.115-.172v-5.675c0-.07.044-.136.115-.172l5.633-2.837a.261.261 0 01.231 0l5.633 2.837c.071.036.115.102.115.172v5.675c0 .07-.044.136-.115.172l-5.633 2.837a.257.257 0 01-.115.027zm-5.403-3.15l5.404 2.72 5.403-2.72v-5.446l-5.403-2.721-5.404 2.72v5.446z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M42.02 386.414a.257.257 0 01-.115-.027l-5.54-2.786c-.11-.055-.147-.177-.083-.272.064-.095.204-.127.314-.072l5.425 2.727 5.388-2.709c.11-.055.25-.023.314.072s.027.217-.083.272l-5.504 2.768a.26.26 0 01-.115.027z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M42.02 391.955c-.126 0-.23-.089-.23-.199v-5.541c0-.11.104-.2.23-.2.127 0 .23.09.23.2v5.541c0 .11-.103.2-.23.2zM44.897 384.947a.258.258 0 01-.114-.026l-5.658-2.804c-.11-.055-.149-.177-.086-.272.063-.096.204-.129.314-.074l5.658 2.804c.11.055.149.177.086.272a.238.238 0 01-.2.1z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M40.68 390.188a.257.257 0 01-.116-.027l-3.066-1.541a.196.196 0 01-.114-.172v-3.21c0-.07.043-.136.114-.172a.261.261 0 01.23 0l3.066 1.528a.196.196 0 01.115.173v3.221a.196.196 0 01-.115.173.257.257 0 01-.115.027zm-2.836-1.855l2.605 1.31v-2.761l-2.605-1.3v2.75z",
                                        fillRule: "nonzero"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(42.02 386.215)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.916,
                                        rx: 3.909,
                                        ry: 3.916
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.932,
                                            y: 5.957,
                                            children: "1"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34,
                        fill: "#FFF",
                        x: 255.996,
                        y: 282.49,
                        width: 215.842,
                        height: 119.808,
                        rx: 4.633
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 264.765,
                        y: 322.746,
                        width: 183.632,
                        height: 4.523,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 264.765,
                        y: 330.147,
                        width: 166.262,
                        height: 4.523,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#CBD7E6",
                        x: 296.603,
                        y: 293.081,
                        width: 85.612,
                        height: 6.99,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 296.603,
                        y: 302.95,
                        width: 134.002,
                        height: 4.523,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#F0F4FA",
                        x: 264.765,
                        y: 340.016,
                        width: 85.612,
                        height: 4.523,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 264.765,
                        y: 358.518,
                        width: 42.599,
                        height: 9.457,
                        rx: 4.729
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "#EDF5FA",
                        x: 313.568,
                        y: 357.285,
                        width: 43.013,
                        height: 9.457,
                        rx: 4.729
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M317.372 383.766c.24.237.43.52.574.805.526 1.089.359 2.462-.574 3.362l-2.558 2.557c-1.171 1.16-3.06 1.16-4.208 0-1.171-1.16-1.171-3.03 0-4.167l1.817-1.8a3.326 3.326 0 00.072 2.155l-.765.758c-.526.52-.526 1.397 0 1.941a1.38 1.38 0 001.96 0l2.559-2.533c.263-.26.406-.616.406-.97 0-.356-.143-.711-.406-.972a1.402 1.402 0 00-.98-.402l1.29-1.279c.287.119.55.308.813.545z",
                                fill: "#FFD15C"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M313.547 387.554c-.24-.237-.43-.52-.574-.805-.526-1.089-.359-2.462.574-3.362l2.558-2.557c1.172-1.16 3.06-1.16 4.208 0 1.172 1.16 1.172 3.03 0 4.167l-1.817 1.8a3.326 3.326 0 00-.072-2.155l.765-.758c.526-.52.526-1.397 0-1.941a1.38 1.38 0 00-1.96 0l-2.535 2.557c-.263.26-.406.615-.406.97 0 .356.143.71.406.971.263.26.622.403.98.403l-1.29 1.278a3.26 3.26 0 01-.837-.568z",
                                fill: "#FF7058"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(315.47 385.67)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.829,
                                        cy: 3.807,
                                        rx: 3.829,
                                        ry: 3.807
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.393,
                                            y: 5.841,
                                            children: "5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M332.225 385.247h1.227v4.474h-1.227z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M333.043 385.247h.468v4.474h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.634 384.065l-5.033-3.268a.15.15 0 00-.162 0l-5.032 3.268v.369h10.227v-.37z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M336.654 380.797a.147.147 0 00-.16 0l-.178.117 4.8 3.15v.37h.518v-.37l-4.98-3.267z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M336.725 382.807a.408.408 0 01-.41.406.408.408 0 01-.408-.406c0-.225.183-.407.409-.407.226 0 .409.182.409.407z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M333.713 385.247h-1.749c-.082 0-.148-.05-.148-.111v-.702h2.045v.702c0 .061-.066.111-.148.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M333.219 384.434v.702c0 .061-.079.111-.176.111h.643c.097 0 .175-.05.175-.111v-.702h-.642z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M333.713 389.72h-1.749c-.082 0-.148.05-.148.112v.702h2.045v-.702c0-.062-.066-.111-.148-.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M333.219 390.534v-.702c0-.061-.079-.111-.176-.111h.643c.097 0 .175.05.175.11v.703h-.642z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M335.907 385.247h1.227v4.474h-1.227z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M336.725 385.247h.468v4.474h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M337.395 385.247h-1.75c-.081 0-.147-.05-.147-.111v-.702h2.045v.702c0 .061-.066.111-.148.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M336.9 384.434v.702c0 .061-.078.111-.175.111h.643c.097 0 .175-.05.175-.111v-.702h-.643z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M337.395 389.72h-1.75c-.081 0-.147.05-.147.112v.702h2.045v-.702c0-.062-.066-.111-.148-.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M336.9 390.534v-.702c0-.061-.078-.111-.175-.111h.643c.097 0 .175.05.175.11v.703h-.643z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#E6F1FA",
                                        d: "M339.588 385.247h1.228v4.474h-1.228z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        fill: "#CEE4F7",
                                        d: "M340.407 385.247h.468v4.474h-.468z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.077 385.247h-1.75c-.081 0-.148-.05-.148-.111v-.702h2.046v.702c0 .061-.067.111-.148.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M340.582 384.434v.702c0 .061-.079.111-.175.111h.642c.097 0 .176-.05.176-.111v-.702h-.643z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.077 389.72h-1.75c-.081 0-.148.05-.148.112v.702h2.046v-.702c0-.062-.067-.111-.148-.111z",
                                        fill: "#537D91"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M340.582 390.534v-.702c0-.061-.079-.111-.175-.111h.642c.097 0 .176.05.176.11v.703h-.643z",
                                        fill: "#45738A"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.496 384.84h-10.36c-.076 0-.138-.066-.138-.147v-.519c0-.081.062-.147.138-.147h10.36c.076 0 .138.066.138.147v.519c0 .081-.062.147-.138.147z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.867 384.027h-.642c.096 0 .175.066.175.147v.519c0 .081-.079.147-.175.147h.642c.097 0 .176-.066.176-.147v-.519c0-.081-.079-.147-.176-.147z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.634 391.754h-10.636v-1.072c0-.082.062-.148.138-.148h10.36c.076 0 .138.066.138.148v1.072z",
                                        fill: "#FEDA43"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.867 390.534h-.642c.096 0 .175.066.175.148v1.072h.643v-1.072c0-.082-.079-.148-.176-.148z",
                                        fill: "#FDB53E"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M341.905 392.161h-11.178c-.076 0-.138-.066-.138-.147v-.52c0-.08.062-.146.138-.146h11.178c.076 0 .138.066.138.147v.519c0 .081-.062.147-.138.147z",
                                        fill: "#E6F1FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M342.277 391.348h-.643c.097 0 .175.066.175.147v.519c0 .081-.078.147-.175.147h.643c.096 0 .175-.066.175-.147v-.52c0-.08-.079-.146-.175-.146z",
                                        fill: "#CEE4F7"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M336.52 383.62a.612.612 0 00.614-.61.613.613 0 00-1.227 0c0 .337.275.61.613.61zm.003-.84a.234.234 0 110 .469.234.234 0 010-.469z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M342.278 391.046h-.21v-.595a.174.174 0 00-.174-.173h-.594v-.594a.174.174 0 00-.173-.174h-.21v-3.804h.21a.174.174 0 00.173-.174v-.594h.594a.174.174 0 00.174-.174v-.768a.174.174 0 00-.174-.174h-.33l-4.945-3.425a.174.174 0 00-.198 0l-4.945 3.425h-.33a.174.174 0 00-.173.174v.768c0 .096.078.174.173.174h.594v.594c0 .096.078.174.174.174h.21v3.804h-.21a.174.174 0 00-.174.174v.594h-.594a.174.174 0 00-.173.173v.595h-.21a.174.174 0 00-.174.173v.768c0 .096.078.174.174.174h11.515a.174.174 0 00.174-.174v-.768a.174.174 0 00-.174-.173zm-1.325-.72h-1.572v-.469h1.572v.468zm-1.188-.816v-3.804h.804v3.804h-.804zm1.188-4.104h-1.572v-.468h1.572v.468zm-1.746.3h.21v3.804h-.21a.174.174 0 00-.173.174v.594h-1.38v-.594a.174.174 0 00-.174-.174h-.21v-3.804h.21a.174.174 0 00.174-.174v-.594h1.38v.594c0 .096.077.174.173.174zm-3.472-.768h1.571v.468h-1.571v-.468zm.383.768h.804v3.804h-.804v-3.804zm1.188 4.151v.468h-1.571v-.468h1.571zm-5.986-5.687h3.033a.174.174 0 000-.348h-2.266l4.433-3.07 4.434 3.07h-5.906a.174.174 0 000 .348h6.672v.42h-10.4v-.42zm.768.768h1.572v.468h-1.572v-.468zm1.188.768v3.804h-.804v-3.804h.804zm-1.188 4.151h1.572v.468h-1.572v-.468zm1.745-.347h-.21v-3.804h.21a.174.174 0 00.174-.174v-.594h1.38v.594c0 .096.078.174.174.174h.21v3.804h-.21a.174.174 0 00-.174.174v.594h-1.38v-.594a.174.174 0 00-.174-.174zm-2.513 1.115h10.4v.468h-10.4v-.468zm10.784 1.236h-11.168v-.468h11.168v.468z",
                                        fill: "#000",
                                        fillRule: "nonzero"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(338.123 385.03)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                fill: "#005AEE",
                                fillRule: "nonzero",
                                cx: 3.73,
                                cy: 3.86,
                                rx: 3.73,
                                ry: 3.86
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                fontFamily: "ProximaNova-Bold, Proxima Nova",
                                fontSize: 4.928,
                                fontWeight: "bold",
                                fill: "#FFF",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                    x: 2.332,
                                    y: 5.898,
                                    children: "2"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M289.167 380.545c-.05.583-.676.675-.676.675.537.024.67.709.67.709.012-.488.692-.716.692-.716-.509-.03-.686-.668-.686-.668z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M289.858 381.137c-.447-.026-.614-.606-.616-.612a.078.078 0 00-.082-.056.077.077 0 00-.07.07c-.045.514-.587.603-.61.606a.076.076 0 00-.066.079c.002.039.034.07.074.071.468.022.596.642.598.648a.077.077 0 00.082.061.077.077 0 00.072-.073c.01-.43.632-.645.639-.647a.075.075 0 00.051-.082.077.077 0 00-.072-.065zm-.704.522c-.07-.158-.193-.349-.394-.448a.824.824 0 00.426-.417c.08.155.218.347.432.44-.156.083-.359.222-.464.425z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.041 381.4c-.035.413-.478.478-.478.478.38.018.475.502.475.502.008-.345.489-.507.489-.507-.36-.02-.486-.472-.486-.472z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.531 381.798c-.3-.018-.414-.413-.415-.417a.079.079 0 00-.082-.055.077.077 0 00-.07.069c-.03.346-.397.406-.412.409a.076.076 0 00-.066.078c.002.04.034.07.074.072.313.014.4.436.401.44a.077.077 0 00.083.061.077.077 0 00.072-.074c.006-.287.432-.435.436-.436a.076.076 0 00.052-.082.077.077 0 00-.073-.065zm-.497.342a.653.653 0 00-.23-.266.612.612 0 00.252-.248c.055.095.137.2.256.264a.804.804 0 00-.278.25z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.041 380.057c-.035.412-.478.477-.478.477.38.018.475.502.475.502.008-.345.489-.507.489-.507-.36-.02-.486-.472-.486-.472z",
                                fill: "#D7E057"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.531 380.454c-.3-.018-.414-.413-.415-.417a.079.079 0 00-.082-.056.077.077 0 00-.07.07c-.03.346-.397.406-.412.408a.076.076 0 00-.066.08c.002.038.034.069.074.07.313.015.4.437.401.44a.077.077 0 00.083.062.077.077 0 00.072-.074c.006-.287.432-.435.436-.436a.076.076 0 00.052-.082.077.077 0 00-.073-.065zm-.497.342a.652.652 0 00-.23-.266.613.613 0 00.252-.248c.055.095.137.2.256.264a.804.804 0 00-.278.25z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 380.035h-7.64a.506.506 0 00-.513.499v9.343c0 .389-.162.74-.424.996-.192.185-.436.32-.71.378l-.021.034h8.665c.638 0 1.156-.502 1.156-1.123v-9.628a.505.505 0 00-.513-.499z",
                                fill: "#FCE8CB"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 379.96h-1.916a.077.077 0 00-.078.075c0 .042.035.076.078.076h1.916c.24 0 .435.19.435.423v9.628c0 .578-.484 1.048-1.078 1.048h-8.287a1.53 1.53 0 00.408-.284c.288-.28.447-.653.447-1.049v-9.343a.43.43 0 01.435-.423h4.932a.077.077 0 00.078-.076.077.077 0 00-.078-.075h-4.932a.583.583 0 00-.59.574v9.343c0 .356-.143.69-.402.942-.186.18-.418.304-.671.358a.078.078 0 00-.05.034l-.022.035a.074.074 0 00-.001.076c.013.024.04.04.068.04h8.665c.68 0 1.233-.539 1.233-1.2v-9.628a.583.583 0 00-.59-.574z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M288.076 382.993a.506.506 0 00-.513.498v6.386c0 .778.65 1.408 1.45 1.408.8 0 1.45-.63 1.45-1.408v-6.884h-2.387z",
                                fill: "#87796F"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M290.462 382.917h-2.386a.583.583 0 00-.59.574v2.496c0 .042.034.076.077.076a.077.077 0 00.078-.076v-2.496a.43.43 0 01.435-.423h2.308v6.809c0 .735-.615 1.333-1.371 1.333-.757 0-1.372-.598-1.372-1.333v-3.093a.077.077 0 00-.078-.076.077.077 0 00-.078.076v3.093c0 .818.686 1.484 1.528 1.484s1.527-.666 1.527-1.484v-6.884a.077.077 0 00-.078-.076z",
                                fill: "#3A312A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.504 383.346h-5.428a.41.41 0 00-.417.404v1.732a.41.41 0 00.417.404h5.428a.41.41 0 00.416-.404v-1.732a.41.41 0 00-.416-.404z",
                                fill: "#F16C7A"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.504 383.27h-5.428a.488.488 0 00-.494.48v1.732c0 .265.221.48.494.48h5.428a.488.488 0 00.494-.48v-1.732a.488.488 0 00-.494-.48zm.339 2.212a.334.334 0 01-.339.329h-5.428a.334.334 0 01-.339-.33v-1.73c0-.182.152-.33.339-.33h5.428c.187 0 .339.148.339.33v1.73z",
                                fill: "#3A312A",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M297.572 381.036h-5.565a.343.343 0 00-.348.338v.504c0 .186.156.338.348.338h5.565a.343.343 0 00.348-.338v-.504a.343.343 0 00-.348-.338z",
                                fill: "#8AC6DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#3A312A",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M297.572 380.96h-5.565a.42.42 0 00-.426.414v.504a.42.42 0 00.426.414h5.565a.42.42 0 00.426-.414v-.504a.42.42 0 00-.426-.414zm.27.918a.267.267 0 01-.27.262h-5.565a.267.267 0 01-.27-.262v-.504c0-.145.121-.263.27-.263h5.565c.15 0 .27.118.27.263v.504z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M297.92 386.811h-6.26a.077.077 0 00-.079.076c0 .042.035.076.078.076h6.261a.077.077 0 00.078-.076.077.077 0 00-.078-.076zM297.92 387.868h-6.26a.077.077 0 00-.079.075c0 .042.035.076.078.076h6.261a.077.077 0 00.078-.076.077.077 0 00-.078-.075zM297.92 388.924h-6.26a.077.077 0 00-.079.076c0 .042.035.076.078.076h6.261a.077.077 0 00.078-.076.077.077 0 00-.078-.076zM297.92 389.98h-6.26a.077.077 0 00-.079.077c0 .041.035.075.078.075h6.261a.077.077 0 00.078-.075.077.077 0 00-.078-.076z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M298.615 380.111h-.717c.24 0 .435.19.435.423v9.628c0 .578-.483 1.048-1.077 1.048h.716c.594 0 1.078-.47 1.078-1.048v-9.628a.43.43 0 00-.435-.423z",
                                fill: "#DECAAD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(293.345 385.67)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.807,
                                        rx: 3.909,
                                        ry: 3.807
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.443,
                                            y: 5.841,
                                            children: "4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#D3E6F8",
                                d: "M276.734 388.428l-5.633 2.759-5.633-2.759v-5.516l5.633-2.759 5.633 2.759z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FFF",
                                d: "M265.468 382.921l5.454 2.664 5.748-2.699-5.575-2.733-5.627 2.759z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#A4CFF2",
                                d: "M276.734 388.428v-5.415l-5.594 2.663v5.484z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FD919E",
                                d: "M266.694 384.72v3.12l3.066 1.499v-3.132z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fill: "#4C4372",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.101 391.38a.263.263 0 01-.115-.026l-5.633-2.758c-.071-.035-.115-.099-.115-.168v-5.516c0-.07.044-.133.115-.168l5.633-2.758a.268.268 0 01.23 0l5.634 2.758c.07.035.114.099.114.168v5.516c0 .07-.043.133-.114.168l-5.633 2.758a.263.263 0 01-.116.026zm-5.403-3.063l5.403 2.646 5.403-2.646v-5.294l-5.403-2.646-5.403 2.646v5.294z",
                                        fillRule: "nonzero"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.101 385.864a.263.263 0 01-.115-.027l-5.54-2.708c-.11-.053-.147-.172-.083-.264.063-.093.204-.124.314-.07l5.424 2.651 5.389-2.634c.11-.054.25-.022.314.07.064.093.026.211-.083.265l-5.504 2.69a.265.265 0 01-.116.027z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M271.101 391.251c-.127 0-.23-.087-.23-.193v-5.388c0-.107.103-.194.23-.194s.23.087.23.194v5.388c0 .106-.103.193-.23.193zM273.978 384.438a.265.265 0 01-.115-.026l-5.658-2.726c-.11-.053-.148-.172-.085-.264.063-.093.204-.125.314-.072l5.658 2.726c.11.054.148.172.085.264a.24.24 0 01-.2.098z"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M269.76 389.533a.263.263 0 01-.115-.027l-3.066-1.498c-.071-.034-.115-.098-.115-.167v-3.12c0-.07.044-.133.115-.168a.268.268 0 01.23 0l3.066 1.486c.071.034.115.098.115.168v3.132c0 .07-.044.133-.115.168a.263.263 0 01-.115.026zm-2.836-1.804l2.606 1.274v-2.685l-2.606-1.262v2.673z",
                                        fillRule: "nonzero"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(271.101 385.67)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                                        fill: "#005AEE",
                                        fillRule: "nonzero",
                                        cx: 3.909,
                                        cy: 3.807,
                                        rx: 3.909,
                                        ry: 3.807
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        fontFamily: "ProximaNova-Bold, Proxima Nova",
                                        fontSize: 4.928,
                                        fontWeight: "bold",
                                        fill: "#FFF",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tspan", {
                                            x: 2.932,
                                            y: 5.841,
                                            children: "3"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "url(#prefix__g)",
                        x: 94.349,
                        y: 74.131,
                        width: 164.73,
                        height: 10.993,
                        rx: 0.842
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "url(#prefix__h)",
                        opacity: 0.602,
                        x: 94.349,
                        y: 91.822,
                        width: 51.427,
                        height: 9.73,
                        rx: 4.212
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        fill: "url(#prefix__i)",
                        opacity: 0.606,
                        x: 147.841,
                        y: 91.822,
                        width: 41.318,
                        height: 9.73,
                        rx: 4.633
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        transform: "translate(17.27 50.123)",
                        fill: "url(#prefix__j)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                            cx: 33.907,
                            cy: 33.696,
                            rx: 33.907,
                            ry: 33.696
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        fill: "#FFBE4D",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M274.116 162.749v-5.77a.72.72 0 00-.546-.688.76.76 0 00-.838.321l-6.886 11a.447.447 0 00-.006.467.488.488 0 00.421.235h5.92v5.77a.72.72 0 00.546.688.76.76 0 00.838-.32l6.885-11a.447.447 0 00.006-.468.488.488 0 00-.42-.235h-5.92z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("image", {
                        x: 38.75,
                        y: 155.002,
                        width: 16.848,
                        height: 20.77,
                        xlinkHref: "data:image/png;base64,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"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        transform: "translate(495.331 130.993)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                x: 1.17,
                                y: 1.17,
                                width: 169.51,
                                height: 161.928,
                                rx: 4.633,
                                fill: "#FFF",
                                stroke: "#A9A9A9",
                                strokeWidth: 2.34
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                fillRule: "nonzero",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        cx: 14.742,
                                        cy: 14.742,
                                        r: 14.742,
                                        transform: "translate(14.32 49.28)",
                                        stroke: "#27C088",
                                        strokeWidth: 2.34
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M36.235 61.931a7.152 7.152 0 00-7.39-5.477 7.144 7.144 0 00-6.683 6.316 4.46 4.46 0 00-3.609 4.8 4.467 4.467 0 004.455 4.034h12.083a4.914 4.914 0 004.889-4.33 4.905 4.905 0 00-3.745-5.343zm-7.627 5.918l-2.986-2.985 1.266-1.262 1.72 1.714 3.314-3.303 1.266 1.261-4.58 4.575z",
                                        fill: "#52C1FF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                cx: 14.742,
                                cy: 14.742,
                                r: 14.742,
                                fillRule: "nonzero",
                                stroke: "#27C088",
                                strokeWidth: 2.34,
                                transform: "translate(14.32 11.372)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M22.055 19.413l-1.752 2.585.923 1.361a3.4 3.4 0 01.505 2.66l-.538 2.378c-.523 2.315.623 4.684 2.78 5.745l5.09 2.502 5.09-2.502c2.156-1.061 3.303-3.43 2.78-5.745l-.538-2.379a3.4 3.4 0 01.505-2.659l.923-1.36-1.752-2.586-1.886.464a3.55 3.55 0 01-2.953-.586l-2.17-1.6-2.169 1.6a3.55 3.55 0 01-2.952.586l-1.886-.464z",
                                fill: "#4C9AE8"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FFF4AB",
                                d: "M28.9 22.188l1.111 3.313h3.594l-2.907 2.048 1.11 3.313-2.907-2.047-2.907 2.047 1.11-3.313-2.908-2.048h3.594z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                cx: 14.742,
                                cy: 14.742,
                                r: 14.742,
                                transform: "translate(14.32 87.188)",
                                fillRule: "nonzero",
                                stroke: "#27C088",
                                strokeWidth: 2.34
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FFD58C",
                                d: "M36.012 93.717v11.794h-3.37V93.717z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#52C1FF",
                                d: "M31.38 95.823v11.794h-3.37V95.823z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#FA6D62",
                                d: "M25.904 98.35v11.794h-3.37V98.35z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                cx: 14.742,
                                cy: 14.742,
                                r: 14.742,
                                transform: "translate(14.32 125.096)",
                                fillRule: "nonzero",
                                stroke: "#27C088",
                                strokeWidth: 2.34
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                transform: "translate(21.481 133.52)",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M.6 8.003a.6.6 0 01-.424-1.024l5.54-5.54a.6.6 0 01.848.848l-5.54 5.54a.597.597 0 01-.425.176zM7.342 14.32a.603.603 0 01-.426-1.029l5.533-5.533a.603.603 0 01.853.853l-5.533 5.533a.6.6 0 01-.427.177z",
                                        fill: "#738394"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        fill: "#B3C1C9",
                                        cx: 9.477,
                                        cy: 5.265,
                                        r: 5.265
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M1.01 14.32a.589.589 0 01-.416-1.005L7.84 6.07a.589.589 0 11.833.833l-7.246 7.246a.587.587 0 01-.417.173z",
                                        fill: "#738394"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#CBD7E6",
                                x: 53.914,
                                y: 16.979,
                                width: 96.375,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#F0F4FA",
                                x: 53.914,
                                y: 25.364,
                                width: 44.932,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#CBD7E6",
                                x: 53.914,
                                y: 57.283,
                                width: 59.731,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#F0F4FA",
                                x: 53.914,
                                y: 65.707,
                                width: 73.994,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#CBD7E6",
                                x: 53.071,
                                y: 95.191,
                                width: 86.266,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#F0F4FA",
                                x: 53.071,
                                y: 103.615,
                                width: 73.994,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#CBD7E6",
                                x: 53.914,
                                y: 133.099,
                                width: 100.587,
                                height: 5.135,
                                rx: 0.842
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                fill: "#F0F4FA",
                                x: 53.914,
                                y: 141.523,
                                width: 55.04,
                                height: 5.135,
                                rx: 0.842
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("image", {
                        x: 34.538,
                        y: 290.628,
                        width: 25.272,
                        height: 25.272,
                        xlinkHref: "data:image/png;base64,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"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("image", {
                        x: 264.935,
                        y: 287.68,
                        width: 25.272,
                        height: 25.272,
                        xlinkHref: "data:image/png;base64,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"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        fill: "#FFF",
                        stroke: "#A9A9A9",
                        strokeWidth: 2.34,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: 1.17,
                            y: 1.17,
                            width: 169.51,
                            height: 83.585,
                            rx: 4.633,
                            transform: "translate(495.331 312.952)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        opacity: 0.71,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M521.867 349.596c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.752.633-4.22 0-7.91-6.412-14.322-14.321-14.322-7.91 0-14.321 6.412-14.321 14.321 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M534.082 335.31c0 3.798-1.725 7.193-4.431 9.44-2.114 1.754-4.826 2.319-7.784 2.319-2.937 0-5.631-.55-7.738-2.281a12.238 12.238 0 01-4.477-9.478c0-6.765 5.469-12.25 12.215-12.25 6.746 0 12.215 5.485 12.215 12.25z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M530.29 344.328c-1.09-.948-2.89-1.691-5.073-2.072a.636.636 0 01-.54-.648c.016-.349.016-.718.014-1.103 0-.882 1.08-1.946 1.139-3.185.359-.733.564-1.463.564-2.027 0-.37-.092-.614-.255-.775.088-.461.163-.95.255-1.452.37-2.02-.347-3.476-2.15-4.106-.651-.228-3.352-.688-4.358-1.646-.364-.347-.115 1.607-.445 1.753-1.767.782-2.468 1.997-2.102 4 .092.502.167.99.255 1.451-.162.161-.255.404-.255.775 0 .564.206 1.294.565 2.027.059 1.24 1.139 2.24 1.139 3.185-.002.385-.002.754.013 1.103a.636.636 0 01-.54.648c-2.183.381-3.983 1.124-5.073 2.072a11.625 11.625 0 008.424 3.583c3.321 0 6.314-1.379 8.424-3.583z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M635.59 349.596c6.44 0 11.888-4.25 13.69-10.1.41-1.334.632-2.752.632-4.22 0-7.91-6.412-14.322-14.321-14.322-7.91 0-14.321 6.412-14.321 14.321 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M647.806 335.31c0 3.798-1.725 7.193-4.431 9.44-2.114 1.754-4.826 2.319-7.784 2.319-2.937 0-5.631-.55-7.738-2.281a12.238 12.238 0 01-4.477-9.478c0-6.765 5.469-12.25 12.215-12.25 6.746 0 12.215 5.485 12.215 12.25z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M644.015 344.328c-1.09-.948-2.89-1.691-5.074-2.072a.636.636 0 01-.54-.648c.016-.349.016-.718.014-1.103 0-.882 1.08-1.946 1.139-3.185.359-.733.564-1.463.564-2.027 0-.37-.092-.614-.255-.775.088-.461.163-.95.255-1.452.37-2.02-.347-3.476-2.15-4.106-.651-.228-3.352-.688-4.358-1.646-.364-.347-.115 1.607-.445 1.753-1.767.782-2.468 1.997-2.102 4 .092.502.167.99.255 1.451-.162.161-.255.404-.255.775 0 .564.206 1.294.565 2.027.059 1.24 1.139 2.24 1.139 3.185-.002.385-.002.754.013 1.103a.636.636 0 01-.54.648c-2.183.381-3.983 1.124-5.073 2.072a11.625 11.625 0 008.424 3.583c3.321 0 6.314-1.379 8.424-3.583z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M559.775 349.596c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.752.633-4.22 0-7.91-6.412-14.322-14.321-14.322-7.91 0-14.321 6.412-14.321 14.321 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M572.013 335.26a12.19 12.19 0 01-4.44 9.419c-2.117 1.75-4.835 2.313-7.798 2.313-2.942 0-5.642-.548-7.753-2.276a12.191 12.191 0 01-4.485-9.457c0-6.75 5.48-12.222 12.238-12.222 6.759 0 12.238 5.472 12.238 12.222z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M563.093 341.493c-1.422-.461-.948-1.845-.948-3.19 1.896 1.806 2.37-.5 4.266.422-1.738-2.691-1.499-4.138-1.896-6.458-.277-1.615-1.389-4.152-4.74-4.152-3.352 0-4.464 2.537-4.74 4.152-.397 2.32-.158 3.767-1.896 6.458 1.896-.923 2.37 1.384 4.266-.423 0 1.346.474 2.73-.948 3.19-2.148.698-3.576 2.015-4.264 3.327 2.055 1.667 4.698 2.173 7.582 2.173 2.884 0 5.527-.506 7.581-2.173-.687-1.312-2.116-2.63-4.263-3.326z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M597.683 349.596c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.752.633-4.22 0-7.91-6.412-14.322-14.321-14.322-7.91 0-14.321 6.412-14.321 14.321 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M609.92 335.26a12.19 12.19 0 01-4.439 9.419c-2.117 1.75-4.835 2.313-7.798 2.313-2.942 0-5.642-.548-7.753-2.276a12.191 12.191 0 01-4.485-9.457c0-6.75 5.48-12.222 12.238-12.222 6.759 0 12.238 5.472 12.238 12.222z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M601 341.493c-1.421-.461-.947-1.845-.947-3.19 1.896 1.806 2.37-.5 4.266.422-1.738-2.691-1.499-4.138-1.896-6.458-.277-1.615-1.389-4.152-4.74-4.152-3.352 0-4.464 2.537-4.74 4.152-.397 2.32-.158 3.767-1.896 6.458 1.896-.923 2.37 1.384 4.266-.423 0 1.346.474 2.73-.948 3.19-2.148.698-3.576 2.015-4.264 3.327 2.055 1.667 4.698 2.173 7.582 2.173 2.884 0 5.527-.506 7.581-2.173-.687-1.312-2.116-2.63-4.263-3.326z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        opacity: 0.71,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M521.867 386.24c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.751.633-4.22 0-7.91-6.412-14.321-14.321-14.321-7.91 0-14.321 6.411-14.321 14.32 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M534.082 371.954c0 3.799-1.725 7.194-4.431 9.44-2.114 1.755-4.826 2.32-7.784 2.32-2.937 0-5.631-.55-7.738-2.282a12.238 12.238 0 01-4.477-9.478c0-6.765 5.469-12.25 12.215-12.25 6.746 0 12.215 5.485 12.215 12.25z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M530.29 380.972c-1.09-.947-2.89-1.69-5.073-2.072a.636.636 0 01-.54-.648c.016-.348.016-.718.014-1.102 0-.883 1.08-1.946 1.139-3.186.359-.733.564-1.463.564-2.027 0-.37-.092-.614-.255-.774.088-.462.163-.95.255-1.453.37-2.02-.347-3.476-2.15-4.106-.651-.227-3.352-.687-4.358-1.646-.364-.347-.115 1.607-.445 1.753-1.767.782-2.468 1.998-2.102 4 .092.502.167.99.255 1.452-.162.16-.255.404-.255.774 0 .564.206 1.294.565 2.027.059 1.24 1.139 2.241 1.139 3.186-.002.384-.002.754.013 1.102a.636.636 0 01-.54.648c-2.183.381-3.983 1.125-5.073 2.072a11.625 11.625 0 008.424 3.584c3.321 0 6.314-1.38 8.424-3.584z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M597.683 386.24c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.751.633-4.22 0-7.91-6.412-14.321-14.321-14.321-7.91 0-14.321 6.411-14.321 14.32 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M609.898 371.954c0 3.799-1.725 7.194-4.431 9.44-2.114 1.755-4.826 2.32-7.784 2.32-2.937 0-5.631-.55-7.738-2.282a12.238 12.238 0 01-4.477-9.478c0-6.765 5.469-12.25 12.215-12.25 6.746 0 12.215 5.485 12.215 12.25z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M606.107 380.972c-1.09-.947-2.89-1.69-5.074-2.072a.636.636 0 01-.54-.648c.016-.348.016-.718.014-1.102 0-.883 1.08-1.946 1.139-3.186.359-.733.564-1.463.564-2.027 0-.37-.092-.614-.255-.774.088-.462.163-.95.255-1.453.37-2.02-.347-3.476-2.15-4.106-.651-.227-3.352-.687-4.358-1.646-.364-.347-.115 1.607-.445 1.753-1.767.782-2.468 1.998-2.102 4 .092.502.167.99.255 1.452-.162.16-.255.404-.255.774 0 .564.206 1.294.565 2.027.059 1.24 1.139 2.241 1.139 3.186-.002.384-.002.754.013 1.102a.636.636 0 01-.54.648c-2.183.381-3.983 1.125-5.073 2.072a11.625 11.625 0 008.424 3.584c3.321 0 6.314-1.38 8.424-3.584z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                                opacity: 0.601,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M559.775 386.24c6.44 0 11.887-4.25 13.688-10.1.411-1.334.633-2.751.633-4.22 0-7.91-6.412-14.321-14.321-14.321-7.91 0-14.321 6.411-14.321 14.32 0 7.91 6.412 14.321 14.32 14.321z",
                                        fill: "#6EA7FA"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M572.013 371.904a12.19 12.19 0 01-4.44 9.419c-2.117 1.75-4.835 2.314-7.798 2.314-2.942 0-5.642-.548-7.753-2.276a12.191 12.191 0 01-4.485-9.457c0-6.75 5.48-12.222 12.238-12.222 6.759 0 12.238 5.472 12.238 12.222z",
                                        fill: "#FFF"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M563.093 378.137c-1.422-.461-.948-1.845-.948-3.19 1.896 1.806 2.37-.5 4.266.422-1.738-2.69-1.499-4.138-1.896-6.458-.277-1.615-1.389-4.152-4.74-4.152-3.352 0-4.464 2.537-4.74 4.152-.397 2.32-.158 3.767-1.896 6.458 1.896-.922 2.37 1.384 4.266-.422 0 1.345.474 2.729-.948 3.19-2.148.697-3.576 2.014-4.264 3.327 2.055 1.667 4.698 2.173 7.582 2.173 2.884 0 5.527-.506 7.581-2.173-.687-1.313-2.116-2.63-4.263-3.327z",
                                        fill: "#5B7ACF"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/makers/MakersPageHeader.tsx + 2 modules
var MakersPageHeader = __webpack_require__(33393);
;// CONCATENATED MODULE: ./components/vendor/profile/UpgradeAccountBanner.tsx












function UpgradeAccountBanner(param) {
    var icon = param.icon, _title = param.title, title = _title === void 0 ? "Upgrade to Makers" : _title, _description = param.description, description = _description === void 0 ? "Access a powerful suite of tools to help you showcase you products and connect with local governent innovators." : _description, _plan = param.plan, plan = _plan === void 0 ? "Makers" : _plan, _linkToHref = param.linkToHref, linkToHref = _linkToHref === void 0 ? "/makers" : _linkToHref, _linkProps = param.linkProps, linkProps = _linkProps === void 0 ? {} : _linkProps;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            borderRadius: 4,
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            background: "#fff",
            textAlign: "center",
            padding: 32,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        children: [
            icon || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakersIcon/* default */.Z, {
                width: 80,
                height: 80
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    fontSize: 36,
                    fontWeight: 800,
                    margin: "8px 0 8px",
                    color: palette/* text */.fL
                },
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    color: palette/* mediumGray */.rF,
                    textAlign: "center",
                    marginBottom: 24,
                    maxWidth: 500,
                    fontSize: 18
                },
                children: description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeDrawIcon, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                href: "".concat(linkToHref, "#").concat(MakersPageHeader/* CHOOSE_YOUR_PLAN_CONTAINER_ID */.x)
            }, linkProps), {
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                    size: "large",
                    theme: "primary",
                    color: palette/* greenSuccess */.CU,
                    textColor: palette/* white */.ix,
                    css: {
                        minWidth: 300,
                        marginTop: 24
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Upgrade",
                        id: "0h/lPM"
                    })
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 12,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: linkToHref
                }, linkProps), {
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                        css: {
                            color: palette/* innovatorBlue */.LD,
                            fontSize: 14
                        },
                        children: [
                            "Learn more about",
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontWeight: 600
                                },
                                children: plan
                            })
                        ]
                    })
                }))
            })
        ]
    });
};


/***/ }),

/***/ 6044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getHostname; }
/* harmony export */ });
function getHostname(url) {
    if (!url) {
        return null;
    }
    return url.replace("http://", "").replace("https://", "").replace("www.", "").split(/[/?#]/)[0];
};


/***/ })

}]);